// 由 src/views/smart-workbench/index.vue 的 methods 拆分而来，请勿在此文件之外重复定义同名方法。
// CFO/CSO 报表卡片：CFO 成本/现金/会议纪要/深度分析，CSO BOM 诊断/调价/计划/确认/内化等
// 方法体与原文件逐字节一致（仅调整文件归属）。
export default {
  methods: {
    runCfoScenarioThinking({ thinkingId, title, summary, steps, interval, onComplete }) {
      this.appendLocalMessage(
        'assistant',
        this.renderCeoThinkingCard(thinkingId, steps[0], title, summary, steps.length),
        true
      )
      let stepIdx = 1
      const thinkTimer = setInterval(() => {
        const trackEl = this._findVisibleEl('thinking-track-' + thinkingId)
        if (!trackEl) {
          // DOM 尚未挂载，重试一次
          return
        }
        if (stepIdx < steps.length) {
          this.updateCeoThinkingCard(thinkingId, steps, stepIdx)
          stepIdx++
        } else {
          clearInterval(thinkTimer)
          this.removeThinkingCard(thinkingId)
          setTimeout(() => {
            if (typeof onComplete === 'function') onComplete()
          }, 500)
        }
      }, interval || 1500)
      this.smartAnalysisTimers.push(thinkTimer)
    },
    triggerCfoCostScenario() {
      const thinkingId = 'cfo-cost-thinking-' + Date.now()
      this.runCfoScenarioThinking({
        thinkingId,
        title: '采购降本分析',
        summary: '正在拉取采购合同与供应商报价数据，测算降本兑现率...',
        steps: [
          '读取采购合同与供应商报价数据',
          'SRM采购管理系统：query_supplier_contracts --period 2026',
          '降本兑现率测算模型：calc_savings_rate(target=820, actual=492)',
          '采购降本分析结论已生成'
        ],
        interval: 1200,
        onComplete: () => this.renderCfoCostCard()
      })
    },
    renderCfoCostCard() {
      const cardHtml = `
        <div data-ceo-card="shell" style="background:#ffffff;border:1px solid rgba(45,127,249,0.12);border-radius:14px;padding:16px 18px;box-shadow:0 2px 12px rgba(0,0,0,0.03),0 8px 28px rgba(45,127,249,0.06);width:100%;min-width:280px;box-sizing:border-box;">
          <div style="display:inline-block;padding:3px 10px;border-radius:999px;background:rgba(45,127,249,0.08);color:#2d7ff9;font-size:10px;font-weight:800;margin-bottom:10px;letter-spacing:.3px;">采购降本分析</div>
          <div style="font-size:14px;font-weight:800;color:#0f172a;margin-bottom:6px;">采购降本兑现率仅 60%，三项动作锁定</div>
          <div style="font-size:11px;color:#5f7390;line-height:1.6;margin-bottom:12px;">当前采购降本目标 820 万，实际兑现 492 万。主要缺口来自直降谈判滞后和返利返物确认延迟。</div>
          <div style="display:grid;grid-template-columns:repeat(4,1fr);gap:8px;">
            <div style="text-align:center;padding:10px 6px;border-radius:10px;background:#fff;border:1px solid rgba(0,0,0,0.04);">
              <div style="font-size:20px;font-weight:800;color:#d98213;">60%</div>
              <div style="font-size:10px;color:#8c8c8c;margin-top:2px;">当前兑现率</div>
            </div>
            <div style="text-align:center;padding:10px 6px;border-radius:10px;background:#fff;border:1px solid rgba(0,0,0,0.04);">
              <div style="font-size:20px;font-weight:800;color:#e54b3d;">328万</div>
              <div style="font-size:10px;color:#8c8c8c;margin-top:2px;">兑现缺口</div>
            </div>
            <div style="text-align:center;padding:10px 6px;border-radius:10px;background:#fff;border:1px solid rgba(0,0,0,0.04);">
              <div style="font-size:20px;font-weight:800;color:#0aa66a;">820万</div>
              <div style="font-size:10px;color:#8c8c8c;margin-top:2px;">年度目标</div>
            </div>
            <div style="text-align:center;padding:10px 6px;border-radius:10px;background:#fff;border:1px solid rgba(0,0,0,0.04);">
              <div style="font-size:20px;font-weight:800;color:#2d7ff9;">4周</div>
              <div style="font-size:10px;color:#8c8c8c;margin-top:2px;">追回周期</div>
            </div>
          </div>
        </div>
      `
      this.appendLocalMessage('assistant', cardHtml, true)
    },
    triggerCfoReportScenario() {
      const thinkingId = 'cfo-report-scenario-thinking-' + Date.now()
      this.runCfoScenarioThinking({
        thinkingId,
        title: '经营例会摘要',
        summary: '正在汇总损益表、费用明细与现金流数据，提取本周经营要点...',
        steps: [
          '汇总损益表、费用明细与现金流数据',
          'ERP财务报表模块：aggregate PnL + expense + cashflow',
          '经营例会要点提取引擎：extract_key_topics(period="本周")',
          '本周经营例会摘要已生成'
        ],
        interval: 1200,
        onComplete: () => this.renderCfoMeetingSummaryCard()
      })
    },
    renderCfoMeetingSummaryCard() {
      const cardHtml = `
        <div data-ceo-card="shell" style="background:#ffffff;border:1px solid rgba(45,127,249,0.12);border-radius:14px;padding:16px 18px;box-shadow:0 2px 12px rgba(0,0,0,0.03),0 8px 28px rgba(45,127,249,0.06);width:100%;min-width:280px;box-sizing:border-box;">
          <div style="display:inline-block;padding:3px 10px;border-radius:999px;background:rgba(45,127,249,0.08);color:#2d7ff9;font-size:10px;font-weight:800;margin-bottom:10px;letter-spacing:.3px;">经营例会摘要</div>
          <div style="font-size:14px;font-weight:800;color:#0f172a;margin-bottom:6px;">本周核心议题：毛利率回升与采购降本</div>
          <div style="font-size:11px;color:#5f7390;line-height:1.7;">
            <b>1. 毛利率：</b>连续3月下滑至14.5%，重点为物料替代料验证和C客户涨价谈判。<br>
            <b>2. 采购降本：</b>兑现率60%，差328万。<br>
            <b>3. 质量损失：</b>返工率升至4.3%，材料损耗增加。<br>
            <b>4. 决策事项：</b>是否启动PCB/铜/锡等物料替代料紧急采购？是否接受C客户OEM涨价3%的反提案？
          </div>
        </div>
      `
      this.appendLocalMessage('assistant', cardHtml, true)
    },
    triggerCfoCashScenario() {
      const thinkingId = 'cfo-cash-thinking-' + Date.now()
      this.runCfoScenarioThinking({
        thinkingId,
        title: '现金流压力测试',
        summary: '正在加载现金流模型参数与应收应付数据，模拟保守情景...',
        steps: [
          '加载现金流模型参数与应收应付数据',
          '资金管理系统(TMS)：stress_test --scenario conservative --horizon Q4',
          '现金流压力测试引擎：simulate_cashflow(margin=14.5%, horizon=Q4)',
          '压力测试结果与建议已生成'
        ],
        interval: 1200,
        onComplete: () => this.renderCfoCashStressCard()
      })
    },
    renderCfoCashStressCard() {
      const cardHtml = `
        <div data-ceo-card="shell" style="background:#ffffff;border:1px solid rgba(45,127,249,0.12);border-radius:14px;padding:16px 18px;box-shadow:0 2px 12px rgba(0,0,0,0.03),0 8px 28px rgba(45,127,249,0.06);width:100%;min-width:280px;box-sizing:border-box;">
          <div style="display:inline-block;padding:3px 10px;border-radius:999px;background:rgba(45,127,249,0.08);color:#2d7ff9;font-size:10px;font-weight:800;margin-bottom:10px;letter-spacing:.3px;">现金流压力测试</div>
          <div style="font-size:14px;font-weight:800;color:#0f172a;margin-bottom:6px;">若毛利率持续低于 15%，Q4 现金流将承压</div>
          <div style="font-size:11px;color:#5f7390;line-height:1.6;margin-bottom:12px;">基于保守情景（毛利率14.5%维持2个月），预计Q4经营现金流缺口约 <b style="color:#e54b3d;">1,860 万</b>。建议提前与银行沟通授信额度、加快应收账款回收、推迟非关键资本开支。</div>
          <div style="display:grid;grid-template-columns:repeat(4,1fr);gap:8px;">
            <div style="text-align:center;padding:10px 6px;border-radius:10px;background:#fff;border:1px solid rgba(0,0,0,0.04);">
              <div style="font-size:20px;font-weight:800;color:#e54b3d;">1,860万</div>
              <div style="font-size:10px;color:#8c8c8c;margin-top:2px;">Q4预计缺口</div>
            </div>
            <div style="text-align:center;padding:10px 6px;border-radius:10px;background:#fff;border:1px solid rgba(0,0,0,0.04);">
              <div style="font-size:20px;font-weight:800;color:#0f172a;">3.2亿</div>
              <div style="font-size:10px;color:#8c8c8c;margin-top:2px;">可用授信额度</div>
            </div>
            <div style="text-align:center;padding:10px 6px;border-radius:10px;background:#fff;border:1px solid rgba(0,0,0,0.04);">
              <div style="font-size:20px;font-weight:800;color:#d98213;">68天</div>
              <div style="font-size:10px;color:#8c8c8c;margin-top:2px;">应收账款周转</div>
            </div>
            <div style="text-align:center;padding:10px 6px;border-radius:10px;background:#fff;border:1px solid rgba(0,0,0,0.04);">
              <div style="font-size:20px;font-weight:800;color:#0aa66a;">安全</div>
              <div style="font-size:10px;color:#8c8c8c;margin-top:2px;">短期流动性</div>
            </div>
          </div>
        </div>
      `
      this.appendLocalMessage('assistant', cardHtml, true)
    },
    cancelCfoMarginAnalysis() {
      const cardHtml = `
        <div data-ceo-card="shell" style="background:#ffffff;border:1px solid #e8ecf0;border-radius:14px;padding:16px;box-shadow:0 4px 16px rgba(0,0,0,0.04);width:100%;min-width:280px;box-sizing:border-box;">
          <div style="min-width:0;width:100%;box-sizing:border-box;">
            <div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;">
              <div style="width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,#64748b,#94a3b8);display:flex;align-items:center;justify-content:center;color:#ffffff;font-size:14px;font-weight:600;">C</div>
              <div>
                <div style="font-size:12px;font-weight:600;color:#1f2937;">财务数字人</div>
                <div style="font-size:10px;color:#8c9bab;">刚刚</div>
              </div>
            </div>
            <div style="font-size:13px;color:#5a6b7e;line-height:1.7;width:100%;">
              已收到您的拒绝指令，本次毛利率分析已取消。如果后续需要分析，可随时再次 @财务CFO数字人 下达指令。
            </div>
          </div>
        </div>
      `
      this.appendLocalMessage('assistant', cardHtml, true)
    },
    renderCfoMarginAnalysisCard() {
      const replyId = 'cfo-analysis-' + Date.now()
      const section1TextId = `cfo-analysis-summary-${replyId}`
      const section3TextId = `cfo-analysis-attribution-${replyId}`

      const summaryText =
        '毛利率当前 17.1%，距目标 18.7% 差 1.6pct，BOM 成本上升为主要拖累因素。' +
        '初步判断：当前毛利率距目标尚有1.6pct差距，BOM物料涨价和采购降本兑现不足为两大核心拖累因素。'

      const cardHtml = `
        <div id="cfo-analysis-stream-${replyId}" style="margin-top:2px;display:flex;flex-direction:column;gap:10px;">

          <div id="cfo-analysis-s0-${replyId}" style="display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">
            <div style="display:flex;align-items:center;gap:8px;">
              <div style="width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,#10b981,#34d399);display:flex;align-items:center;justify-content:center;color:#ffffff;font-size:14px;font-weight:600;">C</div>
              <div>
                <div style="font-size:12px;font-weight:600;color:#1f2937;">财务数字人</div>
                <div style="font-size:10px;color:#8c9bab;">刚刚</div>
              </div>
            </div>
            <div style="display:flex;align-items:center;gap:8px;margin-top:8px;">
              <span style="padding:4px 10px;border-radius:999px;background:#f0fdf4;border:1px solid rgba(34,197,94,0.18);font-size:11px;font-weight:600;color:#10b981;">报表数据分析</span>
              <span style="padding:4px 10px;border-radius:999px;background:#eef4ff;border:1px solid rgba(74,95,243,0.16);font-size:11px;font-weight:600;color:#4A5FF3;">E2E管理口径</span>
            </div>
            <div id="${section1TextId}" style="font-size:13px;color:#5a6b7e;line-height:1.7;width:100%;margin-top:10px;min-height:22px;"></div>
          </div>

          <div id="cfo-analysis-s1-${replyId}" style="display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">
            <div style="display:grid;grid-template-columns:repeat(4,1fr);gap:8px;">
              <div style="padding:10px;border-radius:10px;background:#f8fafc;border:1px solid #e8ecf0;text-align:center;">
                <div style="font-size:10px;color:#94a3b8;margin-bottom:4px;">Q1 平均</div>
                <div style="font-size:18px;font-weight:700;color:#1f2937;">18.0%</div>
              </div>
              <div style="padding:10px;border-radius:10px;background:#f8fafc;border:1px solid #e8ecf0;text-align:center;">
                <div style="font-size:10px;color:#94a3b8;margin-bottom:4px;">Q2 平均</div>
                <div style="font-size:18px;font-weight:700;color:#1f2937;">17.5%</div>
              </div>
              <div style="padding:10px;border-radius:10px;background:#fff7ed;border:1px solid rgba(249,115,22,0.18);text-align:center;">
                <div style="font-size:10px;color:#c2410c;margin-bottom:4px;">5月实际</div>
                <div style="font-size:18px;font-weight:700;color:#dc2626;">17.1%</div>
              </div>
              <div style="padding:10px;border-radius:10px;background:#f0fdf4;border:1px solid rgba(34,197,94,0.18);text-align:center;">
                <div style="font-size:10px;color:#166534;margin-bottom:4px;">目标值</div>
                <div style="font-size:18px;font-weight:700;color:#16a34a;">18.7%</div>
              </div>
            </div>
            <div style="font-size:10px;color:#94a3b8;margin-top:8px;">数据来源：SAP 月结数据（5月）+ E2E 管理口径损益表 + SRM采购管理系统</div>
          </div>

          <div id="cfo-analysis-s2-${replyId}" style="display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">
            <div style="border-collapse:collapse;width:100%;">
              <table style="width:100%;border-collapse:collapse;font-size:11px;">
                <thead>
                  <tr style="background:#f8fafc;">
                    <th style="padding:6px 10px;text-align:left;font-weight:600;color:#64748b;border-bottom:1px solid #e8ecf0;">关键维度</th>
                    <th style="padding:6px 10px;text-align:left;font-weight:600;color:#64748b;border-bottom:1px solid #e8ecf0;">关键因素</th>
                    <th style="padding:6px 10px;text-align:right;font-weight:600;color:#64748b;border-bottom:1px solid #e8ecf0;">毛利影响</th>
                    <th style="padding:6px 10px;text-align:right;font-weight:600;color:#64748b;border-bottom:1px solid #e8ecf0;">贡献度</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style="border-bottom:1px solid #f1f5f9;">
                    <td style="padding:6px 10px;font-weight:500;color:#1f2937;">BOM成本上升</td>
                    <td style="padding:6px 10px;color:#5a6b7e;">PCB/铜/锡等核心物料价格上涨</td>
                    <td style="padding:6px 10px;text-align:right;color:#e54b3d;font-weight:600;">-412万</td>
                    <td style="padding:6px 10px;text-align:right;color:#64748b;">62%</td>
                  </tr>
                  <tr>
                    <td style="padding:6px 10px;font-weight:500;color:#1f2937;">采购降本兑现不足</td>
                    <td style="padding:6px 10px;color:#5a6b7e;">年度降本目标820万仅达成60%</td>
                    <td style="padding:6px 10px;text-align:right;color:#e54b3d;font-weight:600;">-256万</td>
                    <td style="padding:6px 10px;text-align:right;color:#64748b;">38%</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div id="${section3TextId}" style="font-size:10px;color:#94a3b8;margin-top:8px;min-height:16px;"></div>
          </div>

          <div id="cfo-analysis-s3-${replyId}" style="display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">
            <div style="display:flex;align-items:center;justify-content:space-between;padding-top:4px;border-top:1px solid #e8ecf0;">
              <div style="display:flex;gap:6px;">
                <button type="button" onclick="if(window.openE2EReport){window.openE2EReport();}" style="padding:7px 14px;border-radius:8px;font-size:11px;font-weight:600;border:1px solid #e8ecf0;color:#4A5FF3;background:#ffffff;cursor:pointer;">E2E报表</button>
                <button type="button" onclick="if(window.showFactorAnalysis){window.showFactorAnalysis();}" style="padding:7px 14px;border-radius:8px;font-size:11px;font-weight:600;border:1px solid #e8ecf0;color:#4A5FF3;background:#ffffff;cursor:pointer;">因素分析</button>
              </div>
              <button type="button" onclick="if(window.cfoStepDeepAnalysis){window.cfoStepDeepAnalysis();}" style="padding:8px 18px;border-radius:10px;background:linear-gradient(135deg,#10b981,#34d399);color:#ffffff;font-size:12px;font-weight:600;border:none;cursor:pointer;box-shadow:0 2px 8px rgba(16,185,129,0.25);">查看进一步分析</button>
            </div>
          </div>
        </div>
      `
      this.appendLocalMessage('assistant', cardHtml, true)

      // 串行：s0显示 → 打字机完成 → s1显示 → s2显示 → s3显示
      setTimeout(() => {
        this.revealSection(`cfo-analysis-s0-${replyId}`, 'block')
        setTimeout(() => {
          this.smartTypeWriterEffect(section1TextId, summaryText, () => {
            // 摘要打完 → s1指标卡片
            setTimeout(() => {
              this.revealSection(`cfo-analysis-s1-${replyId}`, 'block')
              setTimeout(() => {
                // s1显示 → s2归因表
                this.revealSection(`cfo-analysis-s2-${replyId}`, 'block')
                setTimeout(() => {
                  this.smartTypeWriterEffect(
                    section3TextId,
                    '分析方法：按物料维度 × 供应商维度加权拆解。BOM物料涨价和采购降本兑现不足为两大核心拖累因素。',
                    () => {
                      // 归因打完 → 按钮
                      setTimeout(
                        () => this.revealSection(`cfo-analysis-s3-${replyId}`, 'block'),
                        300
                      )
                    }
                  )
                }, 240)
              }, 280)
            }, 200)
          })
        }, 280)
      }, 120)
    },
    async cfoStepDeepAnalysis() {
      const thinkingId = 'cfo-deep-thinking-' + Date.now()
      const thinkingSteps = [
        '深入钻取 BOM 成本上升的具体物料与供应商明细',
        '量化采购降本兑现缺口，识别三类缺口拆解'
      ]
      this.appendLocalMessage(
        'assistant',
        this.renderCeoThinkingCard(
          thinkingId,
          thinkingSteps[0],
          '毛利率根因深入量化',
          '正在按物料×型号×供应商维度进行深度钻取分析...',
          thinkingSteps.length
        ),
        true
      )
      let stepIdx = 1
      const thinkTimer = setInterval(() => {
        if (stepIdx < thinkingSteps.length) {
          this.updateCeoThinkingCard(thinkingId, thinkingSteps, stepIdx)
          stepIdx++
        } else {
          clearInterval(thinkTimer)
          this.removeThinkingCard(thinkingId)
          setTimeout(() => {
            this.renderCfoDeepAnalysisCard()
          }, 500)
        }
      }, 2000)
      this.smartAnalysisTimers.push(thinkTimer)
    },
    renderCfoDeepAnalysisCard() {
      const replyId = 'cfo-deep-' + Date.now()

      const bomDetailText =
        '<b>物料涨价明细：</b>PCB（FR-4基板）+8.2%、铜（电解铜LME）+5.4%、锡（焊料级）+4.1%。' +
        '影响3款主力型号（A-1000/B-2000/C-500），其中A-1000单台BOM成本上涨68元。6月加权总影响 -412万。<br>' +
        '<b>供应商分析：</b>PCB主供深圳鹏鼎（集中度87%），铜采购依赖江铜（集中度92%），均为单一供应商格局。<br>' +
        '<b>合约状态：</b>仅铜有季度锁价合约（覆盖60%用量），PCB和锡均为现货采购。'

      const procurementText =
        '<b>年度降本目标：</b>820万/年（月均68万），当前累计兑现492万（60%），缺口328万。<br>' +
        '<b>缺口拆解：</b>①直降谈判类：目标450万，实际270万（60%）——3家核心供应商拒绝降价；' +
        '②返利返物类：目标220万，实际132万（60%）——返利确认周期延长；' +
        '③替代料验证类：目标150万，实际90万（60%）——平均验证周期12周。<br>' +
        '<b>供应链风险：</b>若Q3无法追回缺口，全年降本目标达标率预计仅72%。'

      const cardHtml = `
        <div id="cfo-deep-stream-${replyId}" style="margin-top:2px;display:flex;flex-direction:column;gap:10px;">

          <div id="cfo-deep-s0-${replyId}" style="display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">
            <div style="display:flex;align-items:center;gap:8px;">
              <div style="width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,#10b981,#34d399);display:flex;align-items:center;justify-content:center;color:#ffffff;font-size:14px;font-weight:600;">C</div>
              <div>
                <div style="font-size:12px;font-weight:600;color:#1f2937;">财务数字人</div>
                <div style="font-size:10px;color:#8c9bab;">刚刚</div>
              </div>
            </div>
            <div style="font-size:14px;font-weight:700;color:#0f172a;margin-top:10px;">CFO 专项分析</div>
          </div>

          <div id="cfo-deep-s1-${replyId}" style="display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">
            <div style="padding:12px;border-radius:10px;background:#f8fafc;border:1px solid #eef2f7;">
              <div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;">
                <span style="width:22px;height:22px;border-radius:4px;background:#e54b3d;color:#ffffff;font-size:11px;font-weight:700;display:flex;align-items:center;justify-content:center;">1</span>
                <span style="font-size:13px;font-weight:700;color:#0f172a;flex:1;">BOM 成本上升</span>
                <span style="font-size:12px;font-weight:800;color:#e54b3d;">62%</span>
              </div>
              <div style="height:6px;background:#e2e8f0;border-radius:3px;margin-bottom:8px;overflow:hidden;">
                <div style="width:62%;height:100%;background:#e54b3d;border-radius:3px;"></div>
              </div>
              <div id="cfo-deep-bom-text-${replyId}" style="font-size:11px;color:#475569;line-height:1.7;min-height:18px;"></div>
              <div style="margin-top:6px;display:inline-flex;align-items:center;gap:4px;padding:3px 8px;border-radius:4px;background:#fef2f2;font-size:10px;color:#e54b3d;font-weight:600;">紧急 · 启动替代料验证 + 协商季度锁价</div>
            </div>
          </div>

          <div id="cfo-deep-s2-${replyId}" style="display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">
            <div style="padding:12px;border-radius:10px;background:#f8fafc;border:1px solid #eef2f7;">
              <div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;">
                <span style="width:22px;height:22px;border-radius:4px;background:#d98213;color:#ffffff;font-size:11px;font-weight:700;display:flex;align-items:center;justify-content:center;">2</span>
                <span style="font-size:13px;font-weight:700;color:#0f172a;flex:1;">采购降本兑现不足</span>
                <span style="font-size:12px;font-weight:800;color:#d98213;">38%</span>
              </div>
              <div style="height:6px;background:#e2e8f0;border-radius:3px;margin-bottom:8px;overflow:hidden;">
                <div style="width:38%;height:100%;background:#d98213;border-radius:3px;"></div>
              </div>
              <div id="cfo-deep-proc-text-${replyId}" style="font-size:11px;color:#475569;line-height:1.7;min-height:18px;"></div>
              <div style="margin-top:6px;display:inline-flex;align-items:center;gap:4px;padding:3px 8px;border-radius:4px;background:#fff7ed;font-size:10px;color:#d98213;font-weight:600;">中等 · 需CFO推动跨部门协同加速</div>
            </div>
          </div>

          <div id="cfo-deep-s3-${replyId}" style="display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">
            <div style="display:flex;gap:6px;flex-wrap:wrap;align-items:center;">
              <span style="font-size:10px;color:#94a3b8;">跳转：</span>
              <button type="button" onclick="if(window.openE2EReport){window.openE2EReport();}" style="padding:3px 10px;font-size:10px;background:#f0f4ff;color:#4A5FF3;border:1px solid #dde4f0;border-radius:4px;cursor:pointer;">E2E损益表</button>
              <button type="button" onclick="if(window.showFactorAnalysis){window.showFactorAnalysis();}" style="padding:3px 10px;font-size:10px;background:#f0f4ff;color:#722ed1;border:1px solid #e4daf0;border-radius:4px;cursor:pointer;">因素分析</button>
              <button type="button" onclick="if(window.startPVMCMAnalysis){window.startPVMCMAnalysis();}" style="padding:3px 10px;font-size:10px;background:#f0f4ff;color:#d98213;border:1px solid #f0e0c8;border-radius:4px;cursor:pointer;">材差追踪</button>
            </div>
            <div style="text-align:right;margin-top:8px;">
              <button type="button" onclick="if(window.cfoStepReport){window.cfoStepReport();}" style="padding:8px 20px;border-radius:8px;border:none;background:linear-gradient(135deg,#4A5FF3,#2d7ff9);color:#ffffff;font-size:12px;font-weight:700;cursor:pointer;">生成 CFO 报告</button>
            </div>
          </div>
        </div>
      `
      this.appendLocalMessage('assistant', cardHtml, true)

      // 串行
      setTimeout(() => this.revealSection(`cfo-deep-s0-${replyId}`, 'block'), 120)
      setTimeout(() => {
        this.revealSection(`cfo-deep-s1-${replyId}`, 'block')
        setTimeout(() => {
          this.smartTypeWriterEffect(
            `cfo-deep-bom-text-${replyId}`,
            bomDetailText,
            () => {
              setTimeout(() => {
                this.revealSection(`cfo-deep-s2-${replyId}`, 'block')
                setTimeout(() => {
                  this.smartTypeWriterEffect(
                    `cfo-deep-proc-text-${replyId}`,
                    procurementText,
                    () => {
                      setTimeout(
                        () => this.revealSection(`cfo-deep-s3-${replyId}`, 'block'),
                        300
                      )
                    }
                  )
                }, 240)
              }, 400)
            }
          )
        }, 240)
      }, 440)
    },
    async cfoStepReport() {
      const thinkingId = 'cfo-report-thinking-' + Date.now()
      const thinkingSteps = [
        '汇总全部分析结论，整合BOM成本上升与采购降本两大维度的归因结果...',
        '正在编制毛利率回升行动方案：四项关差动作与预期追回金额测算...',
        '关差方案测算完成：PCB替代料+220万，铜/锡锁价+180万，直降谈判+168万，替代料加速+100万',
        '四项关差合计预计追回812万，预测毛利率可恢复至18.0%',
        '正在标注风险提示与待 CEO 决策事项...',
        '决策事项识别：客户涨价谈判风险、MLCC替代料紧急采购、CFO周度跟踪汇报',
        '报告编制完成，正在输出毛利率回升专项行动方案...'
      ]
      this.appendLocalMessage(
        'assistant',
        this.renderCeoThinkingCard(
          thinkingId,
          thinkingSteps[0],
          '生成 CFO 专项报告',
          '正在汇总全链路分析结论与关差方案...',
          thinkingSteps.length
        ),
        true
      )
      let stepIdx = 1
      const thinkTimer = setInterval(() => {
        if (stepIdx < thinkingSteps.length) {
          this.updateCeoThinkingCard(thinkingId, thinkingSteps, stepIdx)
          stepIdx++
        } else {
          clearInterval(thinkTimer)
          this.removeThinkingCard(thinkingId)
          setTimeout(() => {
            this.renderCfoReportCard()
          }, 500)
        }
      }, 2000)
      this.smartAnalysisTimers.push(thinkTimer)
    },
    renderCfoReportCard() {
      const replyId = 'cfo-report-' + Date.now()
      const execSummaryId = `cfo-report-exec-${replyId}`
      const riskId = `cfo-report-risk-${replyId}`
      const decisionId = `cfo-report-decision-${replyId}`

      const execSummaryText =
        '<b>结论一：</b>毛利率从 Q1 的 18.0% 小幅下滑至当前 17.1%，核心根因为 BOM 物料成本上升（62%）和采购降本兑现滞后（38%），均为供应链端因素。<br>' +
        '<b>结论二：</b>四项关差动作预计追回毛利额 118.2 万，预测可将毛利率拉回 18.0% 以上，覆盖 CEO 要求的 18.0% 底线。<br>' +
        '<b>结论三：</b>四项关差动作基于年度降本目标+大宗涨价联动对冲双向计算，采购降本与内单涨价为最高优先级动作。'

      const riskText =
        '<b>1. 涨价谈判风险：</b>C 客户可能拒绝 4% 涨幅，需准备备选方案（降 2% + 锁定 2 年合同）。影响：若涨幅仅实现 50%，预期追回金额减少 143 万。<br>' +
        '<b>2. 采购兑现风险：</b>MLCC 替代料验证可能延迟（供应商样品测试未完成）。影响：若延期 2 周，T+1 月毛利率仅回升至 14.8%。<br>' +
        '<b>3. 产能恢复风险：</b>Q3 为传统淡季，利用率恢复至 85% 有不确定性。影响：若利用率始终低于 78%，固定成本持续承压。'

      const decisionText =
        '<b>决策 1：</b>是否批准对 C 客户的涨价方案（4%，或接受其 3% 反提案）？<br>' +
        '<b>决策 2：</b>是否同意启动 MLCC 替代料紧急采购（预估增加初期成本 32 万，但长期可降本 180 万/年）？<br>' +
        '<b>决策 3：</b>是否需要追加 CFO 周度跟踪汇报至 CEO 工作台？'

      const cardHtml = `
        <div id="cfo-report-stream-${replyId}" style="margin-top:2px;display:flex;flex-direction:column;gap:10px;">

          <div id="cfo-report-s0-${replyId}" style="display:none;">
            <div style="display:flex;align-items:center;gap:8px;">
              <div style="width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,#10b981,#34d399);display:flex;align-items:center;justify-content:center;color:#ffffff;font-size:14px;font-weight:600;">C</div>
              <div>
                <div style="font-size:12px;font-weight:600;color:#1f2937;">财务数字人</div>
                <div style="font-size:10px;color:#8c9bab;">毛利率回升专项行动方案</div>
              </div>
            </div>
          </div>

          <div id="cfo-report-s1-${replyId}" style="display:none;">
            <div style="padding:12px 14px;border-radius:10px;background:linear-gradient(135deg,rgba(45,127,249,0.06),rgba(74,95,243,0.04));border:1px solid rgba(45,127,249,0.12);">
              <div style="font-size:12px;font-weight:700;color:#0f172a;margin-bottom:6px;">执行摘要</div>
              <div id="${execSummaryId}" style="font-size:11px;color:#475569;line-height:1.7;min-height:18px;"></div>
            </div>
          </div>

          <div id="cfo-report-s2-${replyId}" style="display:none;">
            <div>
              <div style="font-size:12px;font-weight:700;color:#0f172a;margin-bottom:8px;padding-left:10px;border-left:3px solid #4A5FF3;">一、现状与问题</div>
              <div style="display:flex;gap:6px;flex-wrap:wrap;">
                <div style="flex:1;min-width:80px;padding:8px;border-radius:8px;background:#fef2f2;text-align:center;">
                  <div style="font-size:14px;font-weight:800;color:#e54b3d;">18.0%→17.1%</div>
                  <div style="font-size:9px;color:#94a3b8;">5个月毛利率走势</div>
                </div>
                <div style="flex:1;min-width:80px;padding:8px;border-radius:8px;background:#fff7ed;text-align:center;">
                  <div style="font-size:14px;font-weight:800;color:#d98213;">-0.9pct</div>
                  <div style="font-size:9px;color:#94a3b8;">累计下滑幅度</div>
                </div>
                <div style="flex:1;min-width:80px;padding:8px;border-radius:8px;background:#f0fdf4;text-align:center;">
                  <div style="font-size:14px;font-weight:800;color:#0aa66a;">18.0%</div>
                  <div style="font-size:9px;color:#94a3b8;">12周目标</div>
                </div>
              </div>
            </div>
          </div>

          <div id="cfo-report-s3-${replyId}" style="display:none;">
            <div>
              <div style="font-size:12px;font-weight:700;color:#0f172a;margin-bottom:8px;padding-left:10px;border-left:3px solid #4A5FF3;">二、根因归因</div>
              <table style="width:100%;font-size:11px;border-collapse:collapse;">
                <thead><tr style="border-bottom:1px solid #e8ecf0;">
                  <th style="text-align:left;padding:6px 8px;color:#64748b;font-weight:600;">归因端</th>
                  <th style="text-align:left;padding:6px 8px;color:#64748b;font-weight:600;">因素</th>
                  <th style="text-align:right;padding:6px 8px;color:#64748b;font-weight:600;">影响</th>
                  <th style="text-align:right;padding:6px 8px;color:#64748b;font-weight:600;">贡献度</th>
                </tr></thead>
                <tbody>
                  <tr style="border-bottom:1px solid #f1f5f9;">
                    <td style="padding:6px 8px;color:#e54b3d;font-weight:700;">BOM成本</td>
                    <td style="padding:6px 8px;">PCB/铜/锡涨价，3款主力型号</td>
                    <td style="padding:6px 8px;text-align:right;color:#e54b3d;font-weight:700;">-412万</td>
                    <td style="padding:6px 8px;text-align:right;font-weight:700;">62%</td>
                  </tr>
                  <tr>
                    <td style="padding:6px 8px;color:#d98213;font-weight:700;">采购降本</td>
                    <td style="padding:6px 8px;">兑现60%，缺口328万</td>
                    <td style="padding:6px 8px;text-align:right;color:#d98213;font-weight:700;">-256万</td>
                    <td style="padding:6px 8px;text-align:right;font-weight:700;">38%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div id="cfo-report-s4-${replyId}" style="display:none;">
            <div>
              <div style="font-size:12px;font-weight:700;color:#0f172a;margin-bottom:8px;padding-left:10px;border-left:3px solid #4A5FF3;">三、关差方案</div>
              <div style="display:flex;flex-direction:column;gap:6px;">
                <div style="display:flex;justify-content:space-between;align-items:center;padding:8px 10px;border-radius:8px;background:#ffffff;border:1px solid rgba(0,0,0,0.05);">
                  <div><b style="font-size:11px;color:#0f172a;">PCB替代料验证与锁价</b><div style="font-size:9px;color:#94a3b8;">采购部 · 李莉</div></div>
                  <div style="text-align:right;"><span style="font-weight:700;color:#0aa66a;font-size:12px;">+220万</span></div>
                </div>
                <div style="display:flex;justify-content:space-between;align-items:center;padding:8px 10px;border-radius:8px;background:#ffffff;border:1px solid rgba(0,0,0,0.05);">
                  <div><b style="font-size:11px;color:#0f172a;">铜/锡季度锁价谈判</b><div style="font-size:9px;color:#94a3b8;">采购部 · 李莉</div></div>
                  <div style="text-align:right;"><span style="font-weight:700;color:#0aa66a;font-size:12px;">+180万</span></div>
                </div>
                <div style="display:flex;justify-content:space-between;align-items:center;padding:8px 10px;border-radius:8px;background:#ffffff;border:1px solid rgba(0,0,0,0.05);">
                  <div><b style="font-size:11px;color:#0f172a;">直降谈判加速与返利催收</b><div style="font-size:9px;color:#94a3b8;">采购部 · 李莉</div></div>
                  <div style="text-align:right;"><span style="font-weight:700;color:#0aa66a;font-size:12px;">+168万</span></div>
                </div>
                <div style="display:flex;justify-content:space-between;align-items:center;padding:8px 10px;border-radius:8px;background:#ffffff;border:1px solid rgba(0,0,0,0.05);">
                  <div><b style="font-size:11px;color:#0f172a;">替代料验证流程加速</b><div style="font-size:9px;color:#94a3b8;">采购部+质量部</div></div>
                  <div style="text-align:right;"><span style="font-weight:700;color:#0aa66a;font-size:12px;">+100万</span></div>
                </div>
              </div>
            </div>
          </div>

          <div id="cfo-report-s5-${replyId}" style="display:none;">
            <div>
              <div style="font-size:12px;font-weight:700;color:#0f172a;margin-bottom:8px;padding-left:10px;border-left:3px solid #4A5FF3;">四、财务预测</div>
              <div style="display:flex;gap:6px;">
                <div style="flex:1;padding:8px;border-radius:6px;background:#f8fafc;text-align:center;">
                  <div style="font-size:10px;color:#94a3b8;">T 6月</div>
                  <div style="font-size:14px;font-weight:800;color:#e54b3d;">17.1%</div>
                </div>
                <div style="flex:1;padding:8px;border-radius:6px;background:#f8fafc;text-align:center;">
                  <div style="font-size:10px;color:#94a3b8;">T+1 7月</div>
                  <div style="font-size:14px;font-weight:800;color:#d98213;">17.5%</div>
                </div>
                <div style="flex:1;padding:8px;border-radius:6px;background:#f8fafc;text-align:center;">
                  <div style="font-size:10px;color:#94a3b8;">T+2 8月</div>
                  <div style="font-size:14px;font-weight:800;color:#0aa66a;">17.8%</div>
                </div>
                <div style="flex:1;padding:8px;border-radius:6px;background:#f8fafc;text-align:center;">
                  <div style="font-size:10px;color:#94a3b8;">T+3 9月</div>
                  <div style="font-size:14px;font-weight:800;color:#0aa66a;">18.0%</div>
                </div>
              </div>
              <div style="font-size:9px;color:#94a3b8;margin-top:6px;">假设：四项动作分月逐步兑现 · 无新增重大不利因素</div>
            </div>
          </div>

          <div id="cfo-report-s6-${replyId}" style="display:none;">
            <div style="margin-bottom:8px;">
              <div style="font-size:12px;font-weight:700;color:#0f172a;margin-bottom:6px;padding-left:10px;border-left:3px solid #4A5FF3;">五、风险提示</div>
              <div id="${riskId}" style="font-size:10px;color:#475569;line-height:1.6;min-height:16px;"></div>
            </div>
          </div>

          <div id="cfo-report-s7-${replyId}" style="display:none;">
            <div style="padding:12px 14px;border-radius:10px;background:linear-gradient(135deg,rgba(245,158,11,0.08),rgba(249,115,22,0.04));border:1px solid rgba(245,158,11,0.2);">
              <div style="font-size:12px;font-weight:700;color:#d98213;margin-bottom:6px;">待CEO决策</div>
              <div id="${decisionId}" style="font-size:11px;color:#475569;line-height:1.7;min-height:16px;"></div>
            </div>
          </div>

          <div id="cfo-report-s8-${replyId}" style="display:none;">
            <div style="font-size:9px;color:#94a3b8;line-height:1.6;">
              数据来源 SAP月结(5月) / E2E管理口径 / SRM采购管理系统<br>
              编制 CFO 数字人 · ONE COSMO 智擎工作台 | v2.0
            </div>
            <div style="display:flex;gap:6px;padding-top:10px;margin-top:8px;border-top:1px solid #f1f5f9;justify-content:flex-end;">
              <button type="button" onclick="(function(b){b.textContent='已上报 CEO 决策';b.style.background='#10b981';b.disabled=true;b.style.opacity='0.7';})(this)" style="padding:7px 14px;font-size:11px;background:#10b981;color:#ffffff;border:none;border-radius:6px;cursor:pointer;font-weight:600;">上报CEO决策</button>
              <button type="button" onclick="if(window.openCfoReportTab){window.openCfoReportTab();}" style="padding:7px 14px;font-size:11px;background:#4A5FF3;color:#ffffff;border:none;border-radius:6px;cursor:pointer;font-weight:600;">打开完整报告</button>
            </div>
          </div>
        </div>
      `
      this.appendLocalMessage('assistant', cardHtml, true)

      // 串行链式
      setTimeout(() => this.revealSection(`cfo-report-s0-${replyId}`, 'block'), 100)
      setTimeout(() => {
        this.revealSection(`cfo-report-s1-${replyId}`, 'block')
        setTimeout(() => {
          this.smartTypeWriterEffect(execSummaryId, execSummaryText, () => {
            setTimeout(() => {
              this.revealSection(`cfo-report-s2-${replyId}`, 'block') // 现状
              setTimeout(() => {
                this.revealSection(`cfo-report-s3-${replyId}`, 'block') // 根因
                setTimeout(() => {
                  this.revealSection(`cfo-report-s4-${replyId}`, 'block') // 关差
                  setTimeout(() => {
                    this.revealSection(`cfo-report-s5-${replyId}`, 'block') // 预测
                    setTimeout(() => {
                      this.revealSection(`cfo-report-s6-${replyId}`, 'block') // 风险
                      setTimeout(() => {
                        this.smartTypeWriterEffect(riskId, riskText, () => {
                          setTimeout(() => {
                            this.revealSection(`cfo-report-s7-${replyId}`, 'block') // 决策
                            setTimeout(() => {
                              this.smartTypeWriterEffect(decisionId, decisionText, () => {
                                setTimeout(
                                  () =>
                                    this.revealSection(
                                      `cfo-report-s8-${replyId}`,
                                      'block'
                                    ),
                                  300
                                ) // 按钮
                              })
                            }, 240)
                          }, 300)
                        })
                      }, 240)
                    }, 300)
                  }, 240)
                }, 300)
              }, 240)
            }, 300)
          })
        }, 240)
      }, 400)
    },
    async csoStepBomDiagnosis() {
      this.forceScrollToBottom()
      const thinkingId = 'cso-bom-thinking-' + Date.now()
      const bomThinkingSteps = [
        '识别 BOM 成本上行，拆解 PCB/铜/锡 涨价归因',
        'BOM 成本拆解：PCB +8.2% / 铜 +5.4% / 锡 +4.1%',
        '评估供应链锁货可能性，确认供应商已发函无降价空间',
        '供应商集中度分析：87%-92% 议价能力弱',
        '锁货可能性评估：已发函，无降价空间',
        '提示是否将供应商成本传导至客户',
        '传导决策提示：建议传导至客户',
        '进入供应商涨价传导·客户调价方案评估流程'
      ]
      this.appendLocalMessage(
        'assistant',
        this.renderCeoThinkingCard(
          thinkingId,
          bomThinkingSteps[0],
          'BOM 成本上升归因分析 · 思考过程',
          '正在分析 BOM 成本上升问题，进行系统性诊断与供应链归因...',
          bomThinkingSteps.length
        ),
        true
      )
      let stepIdx = 1
      const thinkTimer = setInterval(() => {
        if (stepIdx < bomThinkingSteps.length) {
          this.updateCeoThinkingCard(thinkingId, bomThinkingSteps, stepIdx)
          stepIdx++
        } else {
          clearInterval(thinkTimer)
          this.removeThinkingCard(thinkingId)
          setTimeout(() => {
            this.renderCsoBomAnalysis()
          }, 500)
        }
      }, 1500)
      this.smartAnalysisTimers.push(thinkTimer)
    },
    renderCsoBomAnalysis() {
      const analysisId = Date.now()
      const typingId = 'cso-bom-typing-' + analysisId
      const introText =
        '任务已收到。围绕 BOM 成本上升问题，我将进行 4 步分析：① BOM 成本拆解 ② 供应商集中度分析 ③ 锁货可能性评估 ④ 传导决策提示。以下是完整分析过程与结论。'

      const warnTextId = 'cso-bom-warn-' + analysisId
      const warnText =
        '财务总监反馈 BOM 成本上行：PCB 8.2% / 铜 5.4% / 锡 4.1%，供应商集中度 87%-92%。年新增成本约 1,240 万，影响毛利率约 0.9pct。'

      const warningSection = `
        <div style="padding:14px 15px;border-radius:12px;background:linear-gradient(135deg,rgba(74,95,243,0.08),rgba(14,165,233,0.05));border:1px solid rgba(74,95,243,0.16);">
          <div style="display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:8px;">
            <div style="font-size:12px;font-weight:700;color:#1f2937;">BOM 成本上升预警</div>
            <span style="display:inline-flex;align-items:center;padding:3px 10px;border-radius:999px;background:#fef2f2;border:1px solid rgba(229,75,61,0.18);color:#e54b3d;font-size:11px;font-weight:600;">利空</span>
          </div>
          <div id="${warnTextId}" style="font-size:12px;color:#5a6b7e;line-height:1.8;min-height:22px;"></div>
        </div>
      `

      const barChartLoadingId = 'cso-bom-bar-loading-' + analysisId
      const barChartContentId = 'cso-bom-bar-content-' + analysisId
      const barChart = `
        <div style="padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;">
          <div style="font-size:12px;font-weight:700;color:#1f2937;margin-bottom:4px;">BOM 三大物料涨价幅度</div>
          <div style="font-size:11px;color:#94a3b8;margin-bottom:12px;">PCB / 铜 / 锡 涨幅对比（数据来源：ERP + 供应商涨价函）</div>
          <div id="${barChartLoadingId}" style="display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px;padding:20px;color:#8c9bab;font-size:12px;">
            <i class="el-icon-loading" style="font-size:20px;color:#4A5FF3;animation:spin 1s linear infinite;"></i>
            <span style="color:#4A5FF3;font-weight:500;">正在加载物料涨幅数据...</span>
            <div style="display:flex;gap:4px;margin-top:2px;">
              <span style="width:3px;height:3px;border-radius:50%;background:#4A5FF3;animation:pulse 1s infinite;"></span>
              <span style="width:3px;height:3px;border-radius:50%;background:#4A5FF3;animation:pulse 1s infinite 0.2s;"></span>
              <span style="width:3px;height:3px;border-radius:50%;background:#4A5FF3;animation:pulse 1s infinite 0.4s;"></span>
            </div>
          </div>
          <div id="${barChartContentId}" style="display:none;">
            <div style="display:flex;flex-direction:column;gap:10px;">
              <div>
                <div style="display:flex;justify-content:space-between;margin-bottom:4px;">
                  <span style="font-size:11px;color:#64748b;">PCB</span>
                  <span style="font-size:11px;color:#e54b3d;font-weight:600;">8.2%</span>
                </div>
                <div style="height:12px;background:#f1f5f9;border-radius:6px;overflow:hidden;">
                  <div style="height:100%;width:82%;background:#e54b3d;border-radius:6px;transition:width 0.5s ease;"></div>
                </div>
              </div>
              <div>
                <div style="display:flex;justify-content:space-between;margin-bottom:4px;">
                  <span style="font-size:11px;color:#64748b;">铜</span>
                  <span style="font-size:11px;color:#d98213;font-weight:600;">5.4%</span>
                </div>
                <div style="height:12px;background:#f1f5f9;border-radius:6px;overflow:hidden;">
                  <div style="height:100%;width:54%;background:#d98213;border-radius:6px;transition:width 0.5s ease;"></div>
                </div>
              </div>
              <div>
                <div style="display:flex;justify-content:space-between;margin-bottom:4px;">
                  <span style="font-size:11px;color:#64748b;">锡</span>
                  <span style="font-size:11px;color:#4a5ff3;font-weight:600;">4.1%</span>
                </div>
                <div style="height:12px;background:#f1f5f9;border-radius:6px;overflow:hidden;">
                  <div style="height:100%;width:41%;background:#4a5ff3;border-radius:6px;transition:width 0.5s ease;"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      `

      const timelineLoadingId = 'cso-bom-tl-loading-' + analysisId
      const timelineContentId = 'cso-bom-tl-content-' + analysisId
      const timeline = `
        <div style="padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;">
          <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:12px;">
            <div style="font-size:12px;font-weight:700;color:#1f2937;">BOM 涨价归因与传导评估证据链</div>
            <span style="font-size:11px;color:#94a3b8;">4 步</span>
          </div>
          <div id="${timelineLoadingId}" style="display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px;padding:24px;color:#8c9bab;font-size:12px;">
            <i class="el-icon-loading" style="font-size:20px;color:#4A5FF3;animation:spin 1s linear infinite;"></i>
            <span style="color:#4A5FF3;font-weight:500;">正在拉取证据链数据...</span>
            <div style="display:flex;gap:4px;margin-top:2px;">
              <span style="width:3px;height:3px;border-radius:50%;background:#4A5FF3;animation:pulse 1s infinite;"></span>
              <span style="width:3px;height:3px;border-radius:50%;background:#4A5FF3;animation:pulse 1s infinite 0.2s;"></span>
              <span style="width:3px;height:3px;border-radius:50%;background:#4A5FF3;animation:pulse 1s infinite 0.4s;"></span>
            </div>
          </div>
          <div id="${timelineContentId}" style="display:none;">
            <div style="position:relative;padding-left:18px;">
              <div style="position:absolute;left:5px;top:6px;bottom:6px;width:2px;background:#e8ecf0;border-radius:1px;"></div>
              <div style="display:flex;flex-direction:column;gap:14px;">
                <div style="position:relative;">
                  <div style="position:absolute;left:-18px;top:3px;width:8px;height:8px;border-radius:50%;background:#22c55e;box-shadow:0 0 0 2px #ffffff;"></div>
                  <div style="display:flex;align-items:center;gap:6px;flex-wrap:wrap;">
                    <span style="font-size:10px;color:#94a3b8;">08:00</span>
                    <span style="font-size:11px;font-weight:600;color:#1f2937;">财务总览</span>
                    <span style="font-size:10px;color:#94a3b8;font-family:Menlo,Monaco,monospace;">bom_alert</span>
                  </div>
                  <div style="font-size:11px;color:#5a6b7e;margin-top:3px;line-height:1.7;">财务总览反馈：BOM 成本上行，PCB 8.2% / 铜 5.4% / 锡 4.1%，供应商集中度 87%-92%。</div>
                </div>
                <div style="position:relative;">
                  <div style="position:absolute;left:-18px;top:3px;width:8px;height:8px;border-radius:50%;background:#22c55e;box-shadow:0 0 0 2px #ffffff;"></div>
                  <div style="display:flex;align-items:center;gap:6px;flex-wrap:wrap;">
                    <span style="font-size:10px;color:#94a3b8;">08:15</span>
                    <span style="font-size:11px;font-weight:600;color:#1f2937;">成本归因</span>
                    <span style="font-size:10px;color:#94a3b8;font-family:Menlo,Monaco,monospace;">cost_attribution</span>
                  </div>
                  <div style="font-size:11px;color:#5a6b7e;margin-top:3px;line-height:1.7;">涨跌归因分析：PCB 主因铜箔+环氧树脂传导；铜主因 LME 上行；锡主因缅甸选矿减产。年新增成本约 1240 万，影响毛利率约 0.9pct。</div>
                </div>
                <div style="position:relative;">
                  <div style="position:absolute;left:-18px;top:3px;width:8px;height:8px;border-radius:50%;background:#22c55e;box-shadow:0 0 0 2px #ffffff;"></div>
                  <div style="display:flex;align-items:center;gap:6px;flex-wrap:wrap;">
                    <span style="font-size:10px;color:#94a3b8;">08:30</span>
                    <span style="font-size:11px;font-weight:600;color:#1f2937;">寻源采购</span>
                    <span style="font-size:10px;color:#94a3b8;font-family:Menlo,Monaco,monospace;">lock_eval</span>
                  </div>
                  <div style="font-size:11px;color:#5a6b7e;margin-top:3px;line-height:1.7;">锁价可行性评估：供应链已正式致函涨价，集中度 87%-92% 议价能力弱，锁价/保价/空间为 0。</div>
                </div>
                <div style="position:relative;">
                  <div style="position:absolute;left:-18px;top:3px;width:8px;height:8px;border-radius:50%;background:#22c55e;box-shadow:0 0 0 2px #ffffff;"></div>
                  <div style="display:flex;align-items:center;gap:6px;flex-wrap:wrap;">
                    <span style="font-size:10px;color:#94a3b8;">08:45</span>
                    <span style="font-size:11px;font-weight:600;color:#1f2937;">经营决策智能体</span>
                    <span style="font-size:10px;color:#94a3b8;font-family:Menlo,Monaco,monospace;">pass_through_decision</span>
                  </div>
                  <div style="font-size:11px;color:#5a6b7e;margin-top:3px;line-height:1.7;">供应链利润无降价空间，内部消化难再降毛利 0.5pct 不可持续。建议将成本传导至客户，进入客户调价方案评估流程。</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      `

      const tableLoadingId = 'cso-bom-table-loading-' + analysisId
      const tableContentId = 'cso-bom-table-content-' + analysisId
      const compareTable = `
        <div style="padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;">
          <div style="display:flex;gap:12px;font-size:11px;font-weight:600;color:#1f2937;margin-bottom:8px;">
            <div style="width:60px;">评估维度</div>
            <div style="flex:1;text-align:center;">PCB</div>
            <div style="flex:1;text-align:center;">铜</div>
            <div style="flex:1;text-align:center;">锡</div>
          </div>
          <div id="${tableLoadingId}" style="display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px;padding:16px;color:#8c9bab;font-size:12px;">
            <i class="el-icon-loading" style="font-size:20px;color:#4A5FF3;animation:spin 1s linear infinite;"></i>
            <span style="color:#4A5FF3;font-weight:500;">正在加载评估数据...</span>
            <div style="display:flex;gap:4px;margin-top:2px;">
              <span style="width:3px;height:3px;border-radius:50%;background:#4A5FF3;animation:pulse 1s infinite;"></span>
              <span style="width:3px;height:3px;border-radius:50%;background:#4A5FF3;animation:pulse 1s infinite 0.2s;"></span>
              <span style="width:3px;height:3px;border-radius:50%;background:#4A5FF3;animation:pulse 1s infinite 0.4s;"></span>
            </div>
          </div>
          <div id="${tableContentId}" style="display:none;border-top:1px solid #e8ecf0;">
            <div style="display:flex;gap:12px;padding:6px 0;font-size:11px;color:#5a6b7e;border-bottom:1px solid #f1f5f9;">
              <div style="width:60px;">涨幅</div>
              <div style="flex:1;text-align:center;">8.2%</div>
              <div style="flex:1;text-align:center;">5.4%</div>
              <div style="flex:1;text-align:center;">4.1%</div>
            </div>
            <div style="display:flex;gap:12px;padding:6px 0;font-size:11px;color:#5a6b7e;border-bottom:1px solid #f1f5f9;">
              <div style="width:60px;">供应商集中度</div>
              <div style="flex:1;text-align:center;">92%</div>
              <div style="flex:1;text-align:center;">87%</div>
              <div style="flex:1;text-align:center;">87%</div>
            </div>
            <div style="display:flex;gap:12px;padding:6px 0;font-size:11px;color:#5a6b7e;border-bottom:1px solid #f1f5f9;">
              <div style="width:60px;">锁货空间</div>
              <div style="flex:1;text-align:center;">0</div>
              <div style="flex:1;text-align:center;">0</div>
              <div style="flex:1;text-align:center;">0</div>
            </div>
            <div style="display:flex;gap:12px;padding:6px 0;font-size:11px;color:#5a6b7e;">
              <div style="width:60px;">主因</div>
              <div style="flex:1;text-align:center;">铜箔+树脂传导</div>
              <div style="flex:1;text-align:center;">LME 上行</div>
              <div style="flex:1;text-align:center;">缅甸禁矿</div>
            </div>
          </div>
        </div>
      `

      const citations = `
        <div style="padding:14px 15px;border-radius:12px;background:#f8fafc;border:1px solid #e8ecf0;">
          <div style="display:flex;flex-wrap:wrap;gap:8px;">
            <div style="padding:6px 10px;border-radius:6px;background:#ffffff;border:1px solid #e8ecf0;">
              <div style="font-size:10px;color:#94a3b8;">BOM 成本拆解</div>
              <div style="font-size:11px;color:#4a5ff3;font-weight:600;">PCB 8.2% / 铜 5.4% / 锡 4.1%</div>
            </div>
            <div style="padding:6px 10px;border-radius:6px;background:#ffffff;border:1px solid #e8ecf0;">
              <div style="font-size:10px;color:#94a3b8;">供应商集中度分析</div>
              <div style="font-size:11px;color:#4a5ff3;font-weight:600;">87%-92%</div>
            </div>
            <div style="padding:6px 10px;border-radius:6px;background:#ffffff;border:1px solid #e8ecf0;">
              <div style="font-size:10px;color:#94a3b8;">锁货评估</div>
              <div style="font-size:11px;color:#4a5ff3;font-weight:600;">供应商已发函，无降价空间</div>
            </div>
            <div style="padding:6px 10px;border-radius:6px;background:#ffffff;border:1px solid #e8ecf0;">
              <div style="font-size:10px;color:#94a3b8;">传导决策提示</div>
              <div style="font-size:11px;color:#4a5ff3;font-weight:600;">建议传导至客户</div>
            </div>
          </div>
        </div>
      `

      const decisionTextId = 'cso-bom-decision-' + analysisId
      const decisionBtnId = 'cso-bom-decision-btn-' + analysisId
      const decisionText =
        '供应链侧已确认无降价空间，内部消化将再降毛利 0.9pct 不可持续。建议进入<strong style="color:#4a5ff3;">供应商涨价传导 · 客户调价方案评估</strong>流程，生成分级调价方案。'

      const decisionHtml = `
        <div style="padding:14px 15px;border-radius:12px;background:linear-gradient(135deg,rgba(74,95,243,0.08),rgba(14,165,233,0.05));border:1px solid rgba(74,95,243,0.16);">
          <div style="font-size:13px;font-weight:700;color:#1f2937;margin-bottom:8px;">是否将供应商成本传导至客户？</div>
          <div id="${decisionTextId}" style="font-size:12px;color:#5a6b7e;line-height:1.7;margin-bottom:14px;min-height:22px;"></div>
          <div id="${decisionBtnId}" style="display:none;opacity:0;transform:translateY(8px);transition:opacity 0.3s ease, transform 0.3s ease;">
            <div style="display:flex;gap:10px;flex-wrap:wrap;">
              <button type="button" onclick="if(window.csoStepBomNextStep){window.csoStepBomNextStep();}" style="padding:9px 18px;border-radius:12px;border:none;background:linear-gradient(135deg,#4A5FF3,#6B7FFF);color:#fff;font-size:12px;font-weight:600;cursor:pointer;box-shadow:0 2px 8px rgba(74,95,243,0.25);transition:all 0.2s;">是，进入客户调价方案评估</button>
              <button type="button" onclick="if(window.csoStepInternalAbsorb){window.csoStepInternalAbsorb();}" style="padding:9px 18px;border-radius:12px;font-size:12px;font-weight:600;cursor:pointer;color:#5a6b7e;background:#f3f6fb;border:1px solid #e8ecf0;transition:all 0.2s;">否，暂不传导（内部消化）</button>
            </div>
          </div>
        </div>
      `

      const viewReportBtn = `
        <div style="padding:14px 15px;border-radius:12px;background:linear-gradient(135deg,rgba(74,95,243,0.05),rgba(14,165,233,0.03));border:1px solid rgba(74,95,243,0.12);text-align:center;">
          <div style="font-size:11px;color:#4a5ff3;font-weight:600;margin-bottom:8px;">查看完整分析报告与决策选项</div>
          <button type="button" onclick="if(window.csoStepBomNextStep){window.csoStepBomNextStep();}" style="padding:10px 24px;border-radius:12px;border:none;background:linear-gradient(135deg,#4A5FF3,#6B7FFF);color:#fff;font-size:12px;font-weight:600;cursor:pointer;box-shadow:0 2px 8px rgba(74,95,243,0.25);transition:all 0.2s;">BOM成本上升归因与传导决策 →</button>
        </div>
      `

      const sections = [
        warningSection,
        barChart,
        timeline,
        compareTable,
        citations,
        decisionHtml,
        viewReportBtn
      ]
      const sectionIds = sections.map((_, i) => `cso-bom-section-${i}-${analysisId}`)
      const sectionData = [
        { type: 'text', textId: warnTextId, text: warnText },
        {
          type: 'chart',
          loadingId: barChartLoadingId,
          contentId: barChartContentId,
          loadingTime: 800
        },
        {
          type: 'timeline',
          loadingId: timelineLoadingId,
          contentId: timelineContentId,
          loadingTime: 1000
        },
        {
          type: 'table',
          loadingId: tableLoadingId,
          contentId: tableContentId,
          loadingTime: 800
        },
        { type: 'citations' },
        {
          type: 'decision',
          textId: decisionTextId,
          text: decisionText,
          btnId: decisionBtnId
        },
        { type: 'button' }
      ]

      const shellHtml = `
        <div data-ceo-card="shell" style="background:#ffffff;border:1px solid #e8ecf0;border-radius:14px;padding:16px;box-shadow:0 4px 16px rgba(0,0,0,0.04);width:100%;min-width:280px;box-sizing:border-box;">
          <style>@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}@keyframes pulse{0%,100%{opacity:0.3;transform:scale(0.8)}50%{opacity:1;transform:scale(1.2)}}</style>
          <div style="min-width:0;width:100%;box-sizing:border-box;">
            <div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;">
              <div style="width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,#f59e0b,#fbbf24);display:flex;align-items:center;justify-content:center;color:#ffffff;font-size:14px;font-weight:600;">S</div>
              <div>
                <div style="font-size:12px;font-weight:600;color:#1f2937;">供应链CSO数字人</div>
                <div style="font-size:10px;color:#8c9bab;">刚刚</div>
              </div>
            </div>
            <div id="${typingId}" style="font-size:12px;color:#5a6b7e;line-height:1.7;min-height:22px;padding:10px 12px;border-radius:10px;background:#f8fafc;border:1px solid #e8ecf0;margin-bottom:10px;"></div>
            <div id="cso-bom-card-${analysisId}" style="display:flex;flex-direction:column;gap:10px;"></div>
          </div>
        </div>
      `

      this.appendLocalMessage('assistant', shellHtml, true)

      const chars = introText.split('')
      let i = 0
      const typeTimer = setInterval(() => {
        const el = this._findVisibleEl(typingId)
        if (!el) {
          clearInterval(typeTimer)
          return
        }
        if (i < chars.length) {
          el.textContent += chars[i]
          i++
        } else {
          clearInterval(typeTimer)
          setTimeout(() => {
            this.playCsoBomSections(
              'cso-bom-card-' + analysisId,
              sections,
              sectionIds,
              sectionData,
              0
            )
          }, 500)
        }
      }, 25)
      this.smartAnalysisTimers.push(typeTimer)
    },
    playCsoBomSections(shellId, sections, sectionIds, sectionData, idx) {
      if (idx >= sections.length) return
      const shell = this._findVisibleEl(shellId)
      if (!shell) return
      const sectionWrapper = document.createElement('div')
      sectionWrapper.id = sectionIds[idx]
      sectionWrapper.style.display = 'none'
      sectionWrapper.style.opacity = '0'
      sectionWrapper.style.transform = 'translateY(8px)'
      sectionWrapper.style.transition = 'opacity 0.3s ease, transform 0.3s ease'
      sectionWrapper.innerHTML = sections[idx]
      shell.appendChild(sectionWrapper)
      sectionWrapper.style.display = 'block'
      requestAnimationFrame(() => {
        sectionWrapper.style.opacity = '1'
        sectionWrapper.style.transform = 'translateY(0)'
      })
      const data = sectionData[idx]
      if (data.type === 'text') {
        setTimeout(() => {
          this.smartTypeWriterEffect(data.textId, data.text, () => {
            setTimeout(() => {
              this.playCsoBomSections(
                shellId,
                sections,
                sectionIds,
                sectionData,
                idx + 1
              )
            }, 800)
          })
        }, 300)
      } else if (data.type === 'decision') {
        setTimeout(() => {
          this.smartTypeWriterEffect(data.textId, data.text, () => {
            setTimeout(() => {
              const btnEl = this._findVisibleEl(data.btnId)
              if (btnEl) {
                btnEl.style.display = 'block'
                requestAnimationFrame(() => {
                  btnEl.style.opacity = '1'
                  btnEl.style.transform = 'translateY(0)'
                })
              }
              setTimeout(() => {
                this.playCsoBomSections(
                  shellId,
                  sections,
                  sectionIds,
                  sectionData,
                  idx + 1
                )
              }, 800)
            }, 500)
          })
        }, 300)
      } else if (
        data.type === 'chart' ||
        data.type === 'timeline' ||
        data.type === 'table'
      ) {
        setTimeout(() => {
          const loadingEl = this._findVisibleEl(data.loadingId)
          const contentEl = this._findVisibleEl(data.contentId)
          if (loadingEl) loadingEl.style.display = 'flex'
          setTimeout(() => {
            if (loadingEl) loadingEl.style.display = 'none'
            if (contentEl) {
              contentEl.style.display = 'block'
              contentEl.style.opacity = '0'
              contentEl.style.transition = 'opacity 0.5s ease'
              setTimeout(() => {
                contentEl.style.opacity = '1'
              }, 50)
            }
            setTimeout(() => {
              this.playCsoBomSections(
                shellId,
                sections,
                sectionIds,
                sectionData,
                idx + 1
              )
            }, 800)
          }, data.loadingTime)
        }, 300)
      } else {
        setTimeout(() => {
          this.playCsoBomSections(shellId, sections, sectionIds, sectionData, idx + 1)
        }, 600)
      }
    },
    async csoStepBomNextStep() {
      this.forceScrollToBottom()
      this.appendLocalMessage('user', '是，进入客户调价方案评估')

      const thinkingId = 'cso-price-thinking-' + Date.now()
      const thinkingSteps = [
        '正在调取分区域、分客户销售数据进行客户流失风险分析...',
        '客户画像完成：华南3家大客户30天订单下滑6.2%，待决订单1.2亿',
        '正在测算各级客户调价敏感度：A类战略客户/ B类优选/ C类海外...',
        'A类客户评估：海尔、创维为核心战略客户，调价幅度建议3%，配套定制优惠',
        'B类客户评估：长虹华意、东普永磁，调价幅度建议5%，配套阶梯定价+增值服务',
        'C类客户评估：SharkNinja及百余家海外客户，调价幅度8%，配套标准报价+AI沟通',
        '汇总测算：分级调价方案可覆盖成本967万/年，覆盖比例78%',
        '正在梳理客户分级调价证据链，生成分级调价方案报告...'
      ]
      this.appendLocalMessage(
        'assistant',
        this.renderCeoThinkingCard(
          thinkingId,
          thinkingSteps[0],
          '客户流失份额风险分析',
          '正在客户流失份额风险分析，进行系统性诊断与归因分析...',
          thinkingSteps.length
        ),
        true
      )
      let stepIdx = 1
      const thinkTimer = setInterval(() => {
        if (stepIdx < thinkingSteps.length) {
          this.updateCeoThinkingCard(thinkingId, thinkingSteps, stepIdx)
          stepIdx++
        } else {
          clearInterval(thinkTimer)
          this.removeThinkingCard(thinkingId)
          setTimeout(() => {
            this.renderCsoPriceAdjustCard()
          }, 500)
        }
      }, 2000)
      this.smartAnalysisTimers.push(thinkTimer)
    },
    renderCsoPriceAdjustCard() {
      const aid = 'cso-p-' + Date.now()
      const warnText =
        '华南3家大客户30天订单下滑6.2%，待决订单1.2亿。铜箔/MLCC/PCB涨价致成本上行1860万/年。'

      const timeline = [
        {
          time: '07:00',
          name: '销售总览',
          skill: 'sales_alert',
          text:
            '销售总览反馈：华南区域 3 家大客户 30 天订单下滑 6.2%，待决订单 1.2 亿，份额从 12.5% 降至 9.8%。'
        },
        {
          time: '07:15',
          name: '客户画像',
          skill: 'customer_profiling',
          text:
            '客户流失归因分析：海尔/创维采购切换风险，长虹华意、比克电池出现观望情绪，老客户复购率同比下降 28.7%。'
        },
        {
          time: '07:30',
          name: '寻源采购',
          skill: 'cost_attribution',
          text:
            '涨价影响测算：铜箔 +860 万/年，MLCC +420 万/年，PCB +580 万/年，合计 1860 万/年，毛利空间持续被压缩。'
        },
        {
          time: '07:45',
          name: '经营决策智能体',
          skill: 'price_adjust_recommend',
          text:
            '建议进入客户分级调价流程：A 类 3% / B 类 5% / C 类 8%，预计覆盖 78% 成本，触发客户流失止损。'
        }
      ]
      const timelineCount = timeline.length

      const sec1 = `
        <div style="padding:14px 15px;border-radius:12px;background:linear-gradient(135deg,rgba(229,75,61,0.08),rgba(248,113,113,0.04));border:1px solid rgba(229,75,61,0.16);">
          <div style="display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:8px;">
            <div style="font-size:14px;font-weight:700;color:#1f2937;">客户流失初版风险预警</div>
            <span style="display:inline-flex;align-items:center;padding:3px 10px;border-radius:999px;background:#FFF1F2;color:#F43F5E;font-size:11px;font-weight:700;border:1px solid #FECDD3;">利空</span>
          </div>
          <div id="csop-warn-${aid}" style="font-size:12px;color:#5a6b7e;line-height:1.8;min-height:22px;"></div>
        </div>
      `

      const sec2 = `
        <div style="padding:14px;border-radius:12px;background:linear-gradient(180deg,#FAFBFF 0%,#F4F7FF 100%);border:1px solid rgba(74,95,243,0.18);">
          <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:12px;">
            <div style="display:flex;align-items:center;gap:6px;">
              <span style="display:inline-block;width:4px;height:14px;border-radius:2px;background:linear-gradient(180deg,#4A5FF3,#7c3aed);"></span>
              <span style="font-size:13px;font-weight:700;color:#1f2937;">客户流失评估证据链</span>
            </div>
            <span style="font-size:11px;color:#94a3b8;">${timelineCount} 步</span>
          </div>
          <div style="display:flex;flex-direction:column;gap:14px;position:relative;">
            ${timeline
    .map(
      (t, ti) => `
              <div id="csop-step-${ti}-${aid}" style="display:none;opacity:0;transform:translateX(-6px);transition:all .32s ease;display:flex;gap:10px;align-items:flex-start;">
                <div style="flex-shrink:0;width:36px;font-size:11px;color:#94a3b8;font-weight:600;text-align:right;padding-top:2px;line-height:1.5;">${
  t.time
}</div>
                <div style="flex-shrink:0;display:flex;flex-direction:column;align-items:center;width:14px;">
                  <div style="width:12px;height:12px;border-radius:50%;background:${
  ti === timeline.length - 1 ? '#4A5FF3' : '#10b981'
};border:2px solid #fff;box-shadow:0 0 0 2px ${
  ti === timeline.length - 1
    ? 'rgba(74,95,243,0.25)'
    : 'rgba(16,185,129,0.25)'
};margin-top:3px;"></div>
                  ${
  ti < timeline.length - 1
    ? '<div style="width:2px;flex:1;background:linear-gradient(180deg,#10b98140,#10b98110);margin-top:4px;min-height:18px;"></div>'
    : ''
}
                </div>
                <div style="flex:1;min-width:0;">
                  <div style="display:flex;align-items:center;gap:6px;flex-wrap:wrap;">
                    <span style="font-size:12px;font-weight:700;color:#1f2937;">${
  t.name
}</span>
                    <span style="font-size:11px;color:#94a3b8;font-family:Menlo,Monaco,monospace;">${
  t.skill
}</span>
                  </div>
                  <div style="margin-top:4px;padding:8px 10px;border-radius:8px;background:#fff;border:1px solid #EEF2F7;font-size:12px;color:#4b5563;line-height:1.7;">
                    ${t.text}
                  </div>
                </div>
              </div>
            `
    )
    .join('')}
            <div style="margin-top:4px;padding-left:46px;display:flex;align-items:center;gap:6px;font-size:11px;color:#4A5FF3;">
              <span style="font-family:Menlo,Monaco,monospace;">% customer_churn_alert_0625.pdf</span>
            </div>
          </div>
        </div>
      `

      const plan1Text =
        '• 按客户战略价值分A/B/C三档调价3%-8%\n• A类涨幅3%(290万) / B类涨幅5%(480万) / C类涨幅8%(680万)\n• 配合AI生成客户沟通材料，保障核心客户关系\n• 综合评分7.2，成本skill + 寻源skill + 决策skill一致推荐'
      const plan2Text =
        '• 所有客户统一涨5%简化沟通\n• A类大客户可能抵触，存在丢单风险\n• 覆盖度仅50%，剩余930万需内部消化\n• 综合评分4.8，适合客户结构均质场景'
      const plan3Text =
        '• 通过采购谈判 + 工艺优化 + 库存管理内部消化1860万\n• 毛利率再降1.1pct，经营压力极大，不可持续\n• 客户关系短期维护良好\n• 综合评分3.6，仅适合短期客户关系维护'

      const sec3 = `
        <div style="padding:14px;border-radius:12px;background:#fff;border:1px solid #e8ecf0;">
          <div style="display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:10px;flex-wrap:wrap;">
            <div style="font-size:13px;font-weight:700;color:#1f2937;">客户分级 · 调价矩阵 <span style="font-size:11px;color:#94a3b8;font-weight:500;">[1]</span></div>
            <span style="font-size:11px;color:#94a3b8;">数据来源：CRM + 客户合同 2026-06-25</span>
          </div>
          <div style="display:grid;grid-template-columns:88px repeat(3,minmax(0,1fr));gap:0;font-size:12px;overflow-x:auto;background:#fff;border-radius:8px;border:1px solid #EEF2F7;">
            <div style="padding:8px 6px;border-bottom:1px solid #e8ecf0;background:#F8FAFC;font-weight:700;color:#475569;">评估维度</div>
            <div style="padding:8px 6px;border-bottom:1px solid #e8ecf0;background:#F8FAFC;font-weight:700;color:#475569;text-align:center;">A类战略</div>
            <div style="padding:8px 6px;border-bottom:1px solid #e8ecf0;background:#F8FAFC;font-weight:700;color:#475569;text-align:center;">B类优选</div>
            <div style="padding:8px 6px;border-bottom:1px solid #e8ecf0;background:#F8FAFC;font-weight:700;color:#475569;text-align:center;">C类海外</div>

            <div style="padding:8px 6px;border-bottom:1px solid #F1F5F9;color:#475569;font-weight:600;">代表客户</div>
            <div style="padding:8px 6px;border-bottom:1px solid #F1F5F9;text-align:center;color:#1f2937;">海尔、创维</div>
            <div style="padding:8px 6px;border-bottom:1px solid #F1F5F9;text-align:center;color:#1f2937;">长虹华意、东普永磁</div>
            <div style="padding:8px 6px;border-bottom:1px solid #F1F5F9;text-align:center;color:#1f2937;">SharkNinja及百家</div>

            <div style="padding:8px 6px;border-bottom:1px solid #F1F5F9;color:#475569;font-weight:600;">调价幅度</div>
            <div style="padding:8px 6px;border-bottom:1px solid #F1F5F9;text-align:center;color:#4A5FF3;font-weight:700;">3%</div>
            <div style="padding:8px 6px;border-bottom:1px solid #F1F5F9;text-align:center;color:#f59e0b;font-weight:700;">5%</div>
            <div style="padding:8px 6px;border-bottom:1px solid #F1F5F9;text-align:center;color:#dc2626;font-weight:700;">8%</div>

            <div style="padding:8px 6px;border-bottom:1px solid #F1F5F9;color:#475569;font-weight:600;">年贡献量</div>
            <div style="padding:8px 6px;border-bottom:1px solid #F1F5F9;text-align:center;color:#1f2937;">290万</div>
            <div style="padding:8px 6px;border-bottom:1px solid #F1F5F9;text-align:center;color:#1f2937;">480万</div>
            <div style="padding:8px 6px;border-bottom:1px solid #F1F5F9;text-align:center;color:#1f2937;">680万</div>

            <div style="padding:8px 6px;border-bottom:1px solid #F1F5F9;color:#475569;font-weight:600;">流失风险</div>
            <div style="padding:8px 6px;border-bottom:1px solid #F1F5F9;text-align:center;color:#1f2937;">中</div>
            <div style="padding:8px 6px;border-bottom:1px solid #F1F5F9;text-align:center;color:#1f2937;">中</div>
            <div style="padding:8px 6px;border-bottom:1px solid #F1F5F9;text-align:center;color:#1f2937;">高</div>

            <div style="padding:8px 6px;color:#475569;font-weight:600;">沟通策略</div>
            <div style="padding:8px 6px;text-align:center;color:#5a6b7e;">定制优惠</div>
            <div style="padding:8px 6px;text-align:center;color:#5a6b7e;">阶梯定价</div>
            <div style="padding:8px 6px;text-align:center;color:#5a6b7e;">AI沟通材料</div>
          </div>
        </div>
      `

      const sec4 = `
        <div style="padding:12px;border-radius:12px;background:#f0f5ff;border:1px solid #4a5ff3;">
          <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:8px;">
            <div style="font-size:13px;font-weight:700;color:#1f2937;">方案一：分级调价（A 3% / B 5% / C 8%）</div>
            <div style="display:flex;align-items:center;gap:6px;">
              <span style="padding:2px 8px;border-radius:6px;background:#4A5FF3;color:#fff;font-size:10px;font-weight:600;">综合7.2</span>
              <span style="padding:2px 8px;border-radius:6px;background:#10b981;color:#fff;font-size:10px;font-weight:600;">推荐方案</span>
            </div>
          </div>
          <div style="display:grid;grid-template-columns:repeat(4,1fr);gap:8px;margin-bottom:8px;">
            <div style="text-align:center;padding:6px;border-radius:6px;background:#f8fafc;">
              <div style="font-size:11px;font-weight:700;color:#4A5FF3;">78%</div>
              <div style="font-size:9px;color:#94a3b8;">覆盖度</div>
            </div>
            <div style="text-align:center;padding:6px;border-radius:6px;background:#fef3c7;">
              <div style="font-size:11px;font-weight:700;color:#d97706;">低</div>
              <div style="font-size:9px;color:#94a3b8;">风险等级</div>
            </div>
            <div style="text-align:center;padding:6px;border-radius:6px;background:#d1fae5;">
              <div style="font-size:11px;font-weight:700;color:#059669;">高</div>
              <div style="font-size:9px;color:#94a3b8;">A类接受度</div>
            </div>
            <div style="text-align:center;padding:6px;border-radius:6px;background:#f3e8ff;">
              <div style="font-size:11px;font-weight:700;color:#7c3aed;">78%利</div>
              <div style="font-size:9px;color:#94a3b8;">润空间</div>
            </div>
          </div>
          <div id="csop-plan1-${aid}" style="font-size:11px;color:#64748b;line-height:1.6;min-height:18px;"></div>
        </div>
      `

      const sec5 = `
        <div style="padding:12px;border-radius:12px;background:#f8fafc;border:1px solid #e8ecf0;">
          <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:8px;">
            <div style="font-size:13px;font-weight:700;color:#1f2937;">方案二：统一涨价5%</div>
            <span style="padding:2px 8px;border-radius:6px;background:#f1f5f9;color:#64748b;font-size:10px;font-weight:600;">综合4.8</span>
          </div>
          <div style="display:grid;grid-template-columns:repeat(4,1fr);gap:8px;margin-bottom:8px;">
            <div style="text-align:center;padding:6px;border-radius:6px;background:#f8fafc;">
              <div style="font-size:11px;font-weight:700;color:#64748b;">50%</div>
              <div style="font-size:9px;color:#94a3b8;">覆盖度</div>
            </div>
            <div style="text-align:center;padding:6px;border-radius:6px;background:#fef3c7;">
              <div style="font-size:11px;font-weight:700;color:#d97706;">中</div>
              <div style="font-size:9px;color:#94a3b8;">风险等级</div>
            </div>
            <div style="text-align:center;padding:6px;border-radius:6px;background:#fee2e2;">
              <div style="font-size:11px;font-weight:700;color:#dc2626;">低</div>
              <div style="font-size:9px;color:#94a3b8;">A类接受度</div>
            </div>
            <div style="text-align:center;padding:6px;border-radius:6px;background:#f3e8ff;">
              <div style="font-size:11px;font-weight:700;color:#7c3aed;">50%内</div>
              <div style="font-size:9px;color:#94a3b8;">部消化</div>
            </div>
          </div>
          <div id="csop-plan2-${aid}" style="font-size:11px;color:#64748b;line-height:1.6;min-height:18px;"></div>
        </div>
      `

      const sec6 = `
        <div style="padding:12px;border-radius:12px;background:#f8fafc;border:1px solid #e8ecf0;">
          <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:8px;">
            <div style="font-size:13px;font-weight:700;color:#1f2937;">方案三：内部消化（暂不调价）</div>
            <span style="padding:2px 8px;border-radius:6px;background:#f1f5f9;color:#64748b;font-size:10px;font-weight:600;">综合3.6</span>
          </div>
          <div style="display:grid;grid-template-columns:repeat(4,1fr);gap:8px;margin-bottom:8px;">
            <div style="text-align:center;padding:6px;border-radius:6px;background:#fee2e2;">
              <div style="font-size:11px;font-weight:700;color:#dc2626;">0%</div>
              <div style="font-size:9px;color:#94a3b8;">覆盖度(零传导)</div>
            </div>
            <div style="text-align:center;padding:6px;border-radius:6px;background:#fee2e2;">
              <div style="font-size:11px;font-weight:700;color:#dc2626;">高</div>
              <div style="font-size:9px;color:#94a3b8;">风险等级</div>
            </div>
            <div style="text-align:center;padding:6px;border-radius:6px;background:#d1fae5;">
              <div style="font-size:11px;font-weight:700;color:#059669;">高</div>
              <div style="font-size:9px;color:#94a3b8;">客户关系</div>
            </div>
            <div style="text-align:center;padding:6px;border-radius:6px;background:#fee2e2;">
              <div style="font-size:11px;font-weight:700;color:#dc2626;">再降1.1pct</div>
              <div style="font-size:9px;color:#94a3b8;">毛利率</div>
            </div>
          </div>
          <div id="csop-plan3-${aid}" style="font-size:11px;color:#64748b;line-height:1.6;min-height:18px;"></div>
        </div>
      `

      const refsItems = [
        {
          tag: '销售订单总览',
          time: '2026-06-25 07:00',
          desc: '华南 3 家大客户 30 天订单下滑 6.2%，待决订单 1.2 亿'
        },
        {
          tag: '客户画像分析',
          time: '2026-06-25 07:15',
          desc: 'A 类观望 / B 类沟通中 / C 类出现采购切换'
        },
        {
          tag: '涨价影响测算',
          time: '2026-06-25 07:30',
          desc: '铜箔+860万 / MLCC+420万 / PCB+580万 = 1860万/年'
        },
        {
          tag: '分级调价方案',
          time: '2026-06-25 07:45',
          desc: 'A 3% / B 5% / C 8%，覆盖 78%'
        },
        {
          tag: '产品库存',
          time: '2026-06-25 07:50',
          desc: '实时量备料可耗/在途/可用天数',
          link: true
        }
      ]

      const sec7 = `
        <div style="padding:14px;border-radius:12px;background:#fff;border:1px solid #e8ecf0;">
          <div style="font-size:13px;font-weight:700;color:#1f2937;margin-bottom:10px;display:flex;align-items:center;gap:6px;">
            <span style="color:#4A5FF3;">❝</span>引用来源
          </div>
          <div style="display:flex;flex-direction:column;">
            ${refsItems
    .map(
      (r, ri) => `
              <div id="csop-ref-${ri}-${aid}" style="display:none;display:flex;align-items:flex-start;gap:8px;padding:8px 0;${
  ri < refsItems.length - 1 ? 'border-bottom:1px solid #F1F5F9;' : ''
}opacity:0;transform:translateX(-6px);transition:all .32s ease;">
                <span style="font-size:13px;color:#4A5FF3;line-height:1.5;flex-shrink:0;">❝</span>
                <div style="flex:1;min-width:0;">
                  <div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;">
                    <span style="font-size:11px;color:#94a3b8;font-weight:600;">[${
  ri + 1
}]</span>
                    <span style="font-size:12px;font-weight:600;color:#1f2937;">${
  r.tag
}</span>
                    <span style="font-size:11px;color:#94a3b8;">${r.time}</span>
                    ${
  r.link
    ? '<span style="font-size:11px;color:#10b981;margin-left:auto;">↗</span>'
    : ''
}
                  </div>
                  <div style="font-size:11px;color:#5a6b7e;margin-top:4px;padding-left:22px;">${
  r.desc
}</div>
                </div>
              </div>
            `
    )
    .join('')}
          </div>
        </div>
      `

      const sec8 = `
        <div style="padding:14px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;">
          <div style="display:flex;align-items:center;gap:6px;margin-bottom:8px;">
            <span style="display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;border-radius:5px;background:linear-gradient(135deg,#EEF2FF,#E0E7FF);color:#4A5FF3;font-size:11px;line-height:1;">📑</span>
            <span style="font-size:12px;font-weight:600;color:#1f2937;">请选择客户调价方案</span>
          </div>
          <div style="font-size:10px;color:#94a3b8;line-height:1.6;margin-bottom:12px;padding-left:24px;">选定方案后，AI 将生成该方案的总结摘要与对应的客户沟通材料（可重新申请）。</div>
          <div style="display:flex;flex-direction:column;gap:8px;">
            <button type="button" onclick="if(window.csoSelectPlan){window.csoSelectPlan('grade');}" style="display:flex;align-items:center;justify-content:center;gap:6px;width:100%;padding:9px 14px;border-radius:10px;border:none;background:linear-gradient(135deg,#4A5FF3,#6B7FFF);color:#fff;font-size:12px;font-weight:600;cursor:pointer;box-shadow:0 2px 6px rgba(74,95,243,0.18);letter-spacing:0.3px;">
              <span style="display:inline-flex;align-items:center;justify-content:center;width:14px;height:14px;border-radius:50%;background:#fff;color:#4A5FF3;font-size:10px;font-weight:700;line-height:1;">✓</span>
              选择方案一：分波调价（推荐）
            </button>
            <button type="button" onclick="if(window.csoSelectPlan){window.csoSelectPlan('unified');}" style="width:100%;padding:9px 14px;border-radius:10px;border:1px solid #4A5FF3;background:#ffffff;color:#4A5FF3;font-size:12px;font-weight:600;cursor:pointer;letter-spacing:0.3px;">选择方案二：统一涨价 5%</button>
            <button type="button" onclick="if(window.csoSelectPlan){window.csoSelectPlan('internal');}" style="width:100%;padding:8px 14px;border-radius:10px;border:1px solid #e8ecf0;background:#f8fafc;color:#64748b;font-size:12px;font-weight:600;cursor:pointer;letter-spacing:0.3px;">选择方案三：内部消化</button>
          </div>
          <div style="display:flex;justify-content:space-between;margin-top:12px;padding-top:10px;border-top:1px dashed #e8ecf0;">
            <button type="button" onclick="if(window.csoShowDecisionDetail){window.csoShowDecisionDetail();}" style="padding:6px 12px;border-radius:6px;border:1px solid #e8ecf0;background:#fff;color:#64748b;font-size:10px;font-weight:500;cursor:pointer;">查看决策事项详情 →</button>
            <button type="button" onclick="if(window.csoShowInventory){window.csoShowInventory();}" style="padding:6px 12px;border-radius:6px;border:none;background:#f0fdf4;color:#10b981;font-size:10px;font-weight:600;cursor:pointer;">📦 产品库存</button>
          </div>
        </div>
      `

      const allSections = [sec1, sec2, sec3, sec4, sec5, sec6, sec7, sec8]
      const sectionIds = allSections.map((_, i) => `csop-s${i}-${aid}`)
      const shell =
        '<div data-ceo-card="shell" style="background:#ffffff;border:1px solid #e8ecf0;border-radius:14px;padding:16px;box-shadow:0 4px 16px rgba(0,0,0,0.04);width:100%;min-width:280px;box-sizing:border-box;"><div style="min-width:0;width:100%;box-sizing:border-box;"><div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;"><div style="width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,#f59e0b,#fbbf24);display:flex;align-items:center;justify-content:center;color:#fff;font-size:14px;font-weight:600;">S</div><div><div style="font-size:12px;font-weight:600;color:#1f2937;">供应链数字人</div><div style="font-size:10px;color:#8c9bab;">刚刚</div></div></div>' +
        allSections
          .map(
            (html, i) =>
              '<div id="' +
              sectionIds[i] +
              '" style="margin-bottom:10px;display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">' +
              html +
              '</div>'
          )
          .join('') +
        '</div></div>'
      this.appendLocalMessage('assistant', shell, true)

      setTimeout(() => this.revealSection(sectionIds[0], 'block'), 800)
      setTimeout(() => {
        this.smartTypeWriterEffect('csop-warn-' + aid, warnText, () => {
          // === 证据链 (时间线 step by step) ===
          setTimeout(() => {
            this.revealSection(sectionIds[1], 'block')
            let ti = 0
            const showNextStep = () => {
              if (ti >= timelineCount) {
                // === 调价矩阵 (静态) ===
                setTimeout(() => this.revealSection(sectionIds[2], 'block'), 600)
                setTimeout(() => {
                  // === 方案一 (流式输出) ===
                  this.revealSection(sectionIds[3], 'block')
                  setTimeout(() => {
                    this.smartTypeWriterEffect('csop-plan1-' + aid, plan1Text, () => {
                      // === 方案二 ===
                      setTimeout(() => this.revealSection(sectionIds[4], 'block'), 1200)
                      setTimeout(() => {
                        this.smartTypeWriterEffect('csop-plan2-' + aid, plan2Text, () => {
                          // === 方案三 ===
                          setTimeout(
                            () => this.revealSection(sectionIds[5], 'block'),
                            1200
                          )
                          setTimeout(() => {
                            this.smartTypeWriterEffect(
                              'csop-plan3-' + aid,
                              plan3Text,
                              () => {
                                // === 引用来源 (ref by ref) ===
                                setTimeout(() => {
                                  this.revealSection(sectionIds[6], 'block')
                                  let ri = 0
                                  const showNextRef = () => {
                                    if (ri >= refsItems.length) {
                                      setTimeout(
                                        () => this.revealSection(sectionIds[7], 'block'),
                                        800
                                      )
                                      return
                                    }
                                    const refEl = this._findVisibleEl(
                                      `csop-ref-${ri}-${aid}`
                                    )
                                    if (refEl) {
                                      refEl.style.display = 'flex'
                                      void refEl.offsetWidth
                                      refEl.style.opacity = '1'
                                      refEl.style.transform = 'translateX(0)'
                                    }
                                    ri++
                                    setTimeout(showNextRef, 260)
                                  }
                                  setTimeout(showNextRef, 200)
                                }, 1200)
                              }
                            )
                          }, 1200)
                        })
                      }, 1200)
                    })
                  }, 1200)
                }, 1200)
                return
              }
              const stepEl = this._findVisibleEl(`csop-step-${ti}-${aid}`)
              if (stepEl) {
                stepEl.style.display = 'flex'
                void stepEl.offsetWidth
                stepEl.style.opacity = '1'
                stepEl.style.transform = 'translateX(0)'
              }
              ti++
              setTimeout(showNextStep, 320)
            }
            setTimeout(showNextStep, 200)
          }, 800)
        })
      }, 1200)
    },
    async csoSelectPlan(planKey) {
      this.forceScrollToBottom()
      const userMsgMap = {
        grade: '选择方案一：分级调价',
        unified: '选择方案二：统一涨价 5%',
        internal: '选择方案三：内部消化'
      }
      this.appendLocalMessage('user', userMsgMap[planKey])

      const thinkingId = 'cso-select-plan-thinking-' + Date.now()
      const thinkingSteps = ['已确认选择，生成推荐理由', '生成客户沟通材料包']
      this.appendLocalMessage(
        'assistant',
        this.renderCeoThinkingCard(
          thinkingId,
          thinkingSteps[0],
          '生成方案总结与客户沟通材料',
          '正在生成方案推荐理由与预期效果...',
          thinkingSteps.length
        ),
        true
      )
      let stepIdx = 1
      const thinkTimer = setInterval(() => {
        if (stepIdx < thinkingSteps.length) {
          this.updateCeoThinkingCard(thinkingId, thinkingSteps, stepIdx)
          stepIdx++
        } else {
          clearInterval(thinkTimer)
          this.removeThinkingCard(thinkingId)
          setTimeout(() => {
            this.renderCsoPlanSummaryCard(planKey)
          }, 500)
        }
      }, 1000)
      this.smartAnalysisTimers.push(thinkTimer)
    },
    renderCsoPlanSummaryCard(planKeyOrCfg) {
      const planKey =
        typeof planKeyOrCfg === 'string' ? planKeyOrCfg : planKeyOrCfg.planKey
      const planData = {
        grade: {
          planName: '方案一：分级调价（A 3% / B 5% / C 8%）',
          recommendReason:
            '按客户战略价值分A/B/C三档调价3%-8%，综合评分7.0，在覆盖度、风险控制与客户关系维护三维度最优，多智能体一致推荐。',
          expectedEffects: [
            { k: '年化覆盖成本', v: '1,450万（78%）' },
            { k: '毛利率保障', v: '保78%利润空间' },
            { k: 'A类客户留存', v: '高（定制优惠）' },
            { k: '执行周期', v: '7月15日生效' }
          ],
          consensus: '共识: 成本skill + 寻源skill + 决策skill一致推荐',
          commPack: {
            title: 'AI 生成 · 分级调价客户沟通材料包',
            intro:
              '基于全链路成本数据（铜箔+12%/MLCC+8%/PCB+15%）和客户历史合作数据（采购量/战略等级/利润贡献），AI 已自动生成全链路成本分析报告与分档客户沟通材料：',
            materials: [
              {
                label: '全链路成本上涨原因分析报告（供客户对接参考）',
                type: 'report',
                content:
                  '全链路成本上涨原因分析报告\n\n一、上游原材料价格走势\n\n1. 铜箔（LME联动）\n   · LME铜现货价：当前 10,200$/t，近 30 天累计涨幅 18%\n   · 驱动因素：全球铜矿罢工 + 新能源需求拉动 + 美元走弱\n   · 宝钢铜带出厂价：上调 12%（7 月 1 日执行）\n   · 我司铜钢带年采购量：约 7,200 万 → 新增成本 860 万/年\n\n2. MLCC（片式多层陶瓷电容）\n   · 村田/三星原厂：交货涨价 8%\n   · 交期变化：8 周 → 12 周（延长 50%）\n   · 驱动因素：5G/IoT 需求激增 + 日系产能向车规转移\n   · 我司年采购量：约 5,250 万 → 新增成本 420 万/年\n\n3. PCB（印制电路板）\n   · 4 家 PCB 厂商同函涨价：涨价 15%\n   · 驱动因素：铜箔涨价传导 + 环氧树脂涨价 + 环保成本\n   · 我司年采购量：约 3,870 万 → 新增成本 580 万/年\n\n二、成本传导链路分析\n\nLME铜价↑18%\n   ↑→ 铜箔加工费↑ → 铜带出厂价↑12% → PCB 成本↑15%\n   ↑→ 电解铜↑ → 导线/端子成本↑18%\n   ↑→ 黄铜板↑ → 4 板/6 层 PCB 板↑15%\n\n三、我司已采取的降本应对措施\n\n1. 供应端谈判：与宝钢签订 6 个月框架协议\n2. 工艺优化：SMT 贴片效率提升 12%，降低单位人工\n3. 国产替代推进：华大 MCU 替代英飞凌（年降本 240 万）\n4. 库存策略调整：安全库存从 19 天提至 22 天缓冲涨价\n5. 采购批量整合：合并 PO 减少议价频次\n\n四、调价幅度对比（上游 vs 我司传导）\n\n| 物料类别 | 上游涨幅 | 我司传导 | 吸收比例 |\n| -------- | -------- | -------- | -------- |\n| 铜箔     | +12%     | ↑2.3%    | 75% 吸收  |\n|          |          | B 类 5%  | 58% 吸收  |\n|          |          | C 类 8%  | 33% 吸收  |\n| MLCC     | +8%      | 同上     | 同上     |\n| PCB      | +15%     | 同上     | 同上     |\n\n综合加权，我司平均传导幅度仅 5.3%，远低于上游 12%-15% 涨幅\n\n五、后续承诺\n\n· 未来 6 个月内不进行二次调价\n· 若上游原材料价格回落超 5%，启动调价回调机制\n· 持续共享降本成果，定期提供成本透明报告'
              },
              {
                label: 'A 类客户 · 调价沟通函（海尔/创维）',
                type: 'letter',
                content:
                  '尊敬的合作伙伴：\n\n感谢贵司长期以来的信任与支持。受全球铜价持续上行（LME 近 30 天涨 18%）及上游铜箔、MLCC、PCB 供应商集中涨价影响，我司原材料采购本面临系统性上涨压力。\n\n经全链路成本测算，我司将对贵司供应的智控主板/变频模块产品进行 3% 的价格调整，新价格自 2026 年 7 月 15 日起执行。本次调整幅度已充分考虑双方战略合作关系，远低于上游应声平均涨幅（12%-15%），我司自行吸收了约 75% 的新增成本。\n\n同时，我司已完成本优化方案，通过工艺改进与批量采购协议价，承诺未来 6 个月内不再进行二次调价。\n\n随函附《全链路成本上涨原因分析报告》及上游原材料涨价函，供贵司参考。期待继续携手共进。'
              },
              {
                label: 'B 类客户 · 调价沟通函（长虹华意/东普永磁）',
                type: 'letter',
                content:
                  '尊敬的合作伙伴：\n\n受近期铜箔(LME涨18%)、MLCC(涨8%)、PCB(涨15%)三大核心原材料供应商集中涨价影响，我司生产成本面临较大压力。\n\n经审慎评估，我司现对贵司采购产品进行 5% 的价格调整，新价格自 2026 年 7 月 15 日起执行。我司已通过供应端谈判与工艺优化将涨幅控制在合理范围，实际传导比例（约 58%）远低于上游涨幅。\n\n未来我司将继续通过国产替代（如华大 MCU 替代英飞凌）等降本措施降低对上游涨价的依赖。\n\n附件为《全链路成本上涨原因分析报告》及上游原材料涨价函，供贵司审阅。感谢理解与支持。'
              },
              {
                label: 'C 类客户 · 调价沟通函（海外客户/中英双语）',
                type: 'bilingual',
                content:
                  '尊敬的合作伙伴 / Dear Valued Partner：\n\n受近期铜箔(LME涨18%)、MLCC(涨8%)、PCB(涨15%)三大核心原材料供应商集中涨价影响，我司生产成本面临较大压力。经审慎评估，将对贵司采购产品进行 8% 的价格调整，新价格自 2026 年 7 月 15 日起执行。\n\nDue to significant raw material cost increases (Copper Foil +12%, MLCC +8%, PCB +15%) from upstream suppliers, we are implementing an 8% price adjustment effective July 15, 2026.\n\n主要驱动因素 / Key Drivers：\n· LME 铜价近 30 天涨 18% / LME copper price surge: +18% over 30 days\n· MLCC 交期延长至 12 周 / MLCC lead time extended to 12 weeks\n· PCB 材料成本传导上涨 15% / PCB material cost pass-through: +15%\n\n本次 8% 调价仅覆盖上游涨幅的 52%，其余部分由我司内部降本措施吸收。 / The 8% adjustment reflects only 52% of the total upstream increase.\n\n附件/Attachment：\n· 全链路成本上涨原因分析报告 / Full-chain Cost Analysis Report\n· 供应商涨价函(汇总) / Supplier Price Increase Notices\n\n期待继续携手共进 / We value your partnership and remain committed to quality and reliability.\n\nCSO Office'
              }
            ]
          }
        },
        unified: {
          planName: '方案二：统一涨价 5%',
          recommendReason:
            '所有客户统一涨5%简化沟通流程，覆盖50%新增成本，剩余930万通过内部降本消化。适合客户结构相对均质、追求沟通效率的场景。',
          expectedEffects: [
            { k: '年化覆盖成本', v: '930万（50%）' },
            { k: '内部降本压力', v: '930万' },
            { k: 'A类客户风险', v: '中（可能抵触）' },
            { k: '执行周期', v: '7月15日生效' }
          ],
          consensus: '共识: 成本skill + 决策skill推荐（寻源skill存保留意见）',
          commPack: {
            title: 'AI生成 · 统一调价客户沟通材料包',
            intro:
              '采用统一5%调价策略，AI已生成统一版调价沟通函（适用于全部客户），简化沟通流程：',
            materials: [
              {
                label: '统一调价沟通函（全客户通用版）',
                type: 'letter',
                content:
                  '尊敬的合作伙伴：\n\n感谢贵司长期以来的信任与支持。\n\n近期受上游原材料涨价影响，我司成本压力较大。经过审慎评估，决定对所有客户统一执行5%的调价方案，自7月15日起生效。\n\n期待继续携手共进。\n\nCSO Office'
              },
              {
                label: '全链路成本上涨原因分析报告（附件）',
                type: 'report',
                content:
                  '【全链路成本上涨原因分析报告】\n\n一、原材料涨价概况\n铜箔：+12%\nMLCC：+8%\nPCB：+15%\n\n二、影响分析\n综合影响：年新增成本1,860万\n\n三、建议方案\n统一涨价5%'
              }
            ]
          }
        },
        internal: {
          planName: '方案三：内部消化（暂不调价）',
          recommendReason:
            '通过采购谈判、工艺优化、库存管理内部消化全部1,860万成本，毛利率将再降1.1pct。仅适合短期客户关系维护场景，不可持续。',
          expectedEffects: [
            { k: '客户调价', v: '0%（零传导）' },
            { k: '内部降本目标', v: '1,860万' },
            { k: '毛利率影响', v: '再降1.1pct' },
            { k: '风险等级', v: '高（不可持续）' }
          ],
          consensus: '共识: 决策skill提示高风险（仅供短期过渡）',
          commPack: {
            title: 'AI生成 · 内部消化成本管控通知 + 客户关系维护函',
            intro:
              '采用内部消化策略，AI已生成内部成本管控通知（面向采购/质量/生产团队）与客户关系维护函（告知暂不调价但需配合交付节奏）：',
            materials: [
              {
                label: '内部成本管控通知（采购/质量/生产团队）',
                type: 'notice',
                content:
                  '【内部通知】关于启动全链路成本内部消化专项行动的通知\n\n致：采购部 / 质量部 / 生产部 / 财务部\n\n背景：受铜箔(+12%)/MLCC(+8%)/PCB(+15%) 三大原材料涨价影响，年新增成本 1,860 万。经决策层审议，本次不向客户传导调价，由内部全额消化。\n\n一、采购部专项行动\n  1. 与宝钢/鞍钢重启谈判，争取 6 个月框架协议锁价\n  2. MLCC 启动村田/三星外的二供开发（国巨/华新科）\n  3. PCB 引入 2 家备选供应商形成竞价\n  目标：年降本 800 万\n\n二、质量部专项行动\n  1. 加速华大 MCU 替代英飞凌验证（首批 5K 片试单）\n  2. 涂碳铝箔/ PVDF 粘结剂国产替代推进\n  目标：年降本 240 万\n\n三、生产部专项行动\n  1. SMT 贴片效率提升 12%（工艺优化）\n  2. 安全库存从 19 天提至 22 天缓冲涨价\n  3. 合并 PO 减少议价频次\n  目标：年降本 420 万\n\n四、财务部跟踪\n  · 每月跟踪毛利率变动（目标：守住 17.1% 不再下探）\n  · 若 Q3 毛利率跌破 16%，立即启动客户调价预案\n\n本次内部消化压力较大，请各部门于 7 月 15 日前提交专项行动计划。\n\nCSO Office / 2026-06-22'
              },
              {
                label: '客户关系维护函（告知暂不调价 + 交付配合请求）',
                type: 'letter',
                content:
                  '尊敬的合作伙伴：\n\n感谢贵司长期以来的信任与支持。\n\n近期受上游铜箔、MLCC、PCB 供应商集中调价影响，行业整体面临成本压力。经我司内部审慎评估，为维护双方长期合作关系，本次决定暂不向贵司传导调价，由我司内部通过供应商谈判、工艺优化、国产替代等措施全额消化新增成本。\n\n但为确保持续稳定供货，需贵司配合以下事项：\n  1. 月度订单提前 7 天确认，便于我司锁定物料\n  2. 华大 MCU 替代英飞凌方案进入试产阶段，首批产品请贵司协助验证\n  3. 部分非关键物料（如包装材料）允许我司调整供应商\n\n我司承诺：\n  · 未来 6 个月内不进行调价\n  · 持续共享降本成果，定期提供成本透明报告\n  · 若上游价格持续高位，将于 Q4 重新评估调价策略\n\n期待继续携手共进。\n\nCSO Office'
              }
            ]
          }
        }
      }

      const summary = planData[planKey]
      if (!summary) return

      const aid = 'cso-psum-' + Date.now()
      const reasonId = 'cso-psum-reason-' + aid
      const effectWrapId = 'cso-psum-effect-wrap-' + aid
      const introId = 'cso-psum-intro-' + aid
      const matWrapId = 'cso-psum-mat-wrap-' + aid

      const effectsHtml = summary.expectedEffects
        .map(
          (e) => `
        <div style="flex:1 1 0;min-width:0;padding:10px 12px;border-radius:8px;background:linear-gradient(135deg,#eef4ff,#f8fbff);border:1px solid rgba(74,95,243,.15);display:flex;flex-direction:column;justify-content:space-between;min-height:64px;box-sizing:border-box;">
          <div style="font-size:10px;color:#9aa9bb;line-height:1.4;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${e.k}</div>
          <div style="font-size:12px;font-weight:700;color:#4a5ff3;line-height:1.3;word-break:break-all;">${e.v}</div>
        </div>
      `
        )
        .join('')

      const sec1 = `
        <div style="padding:14px;border-radius:12px;background:#fff;border:1px solid rgba(74,95,243,.2);border-left:4px solid #4a5ff3;">
          <div style="display:flex;align-items:center;gap:8px;margin-bottom:10px;flex-wrap:nowrap;">
            <span style="display:inline-flex;align-items:center;gap:4px;padding:3px 10px;border-radius:999px;background:#4a5ff3;color:#fff;font-size:11px;font-weight:600;flex-shrink:0"><i class="fa fa-check-circle" style="font-size:11px;"></i> 已选方案</span>
            <div style="font-size:13px;font-weight:700;color:#1f2937;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:0;flex:1;">${summary.planName}</div>
          </div>
          <div id="${reasonId}" style="padding:10px 12px;border-radius:8px;background:#f8fafc;border:1px solid #e8ecf0;font-size:12px;color:#5a6b7e;line-height:1.8;margin-bottom:10px;min-height:22px;">
            <i class="fa fa-quote-left" style="font-size:10px;color:#4a5ff3;margin-right:4px;"></i>
          </div>
          <div id="${effectWrapId}" style="display:none;opacity:0;transform:translateY(8px);transition:opacity 0.3s ease, transform 0.3s ease;">
            <div style="display:flex;gap:8px;margin-bottom:10px;flex-wrap:wrap;">${effectsHtml}</div>
            <div style="padding:8px 12px;border-radius:8px;background:#ecfdf5;border:1px solid rgba(22,163,74,.18);font-size:11px;color:#16a34a;line-height:1.6;">
              <i class="fa fa-handshake-o" style="font-size:11px;margin-right:4px;"></i>${summary.consensus}
            </div>
          </div>
        </div>
      `

      const pack = summary.commPack
      const idBase = 'comm-' + Date.now() + '-' + Math.floor(Math.random() * 1000)
      const materialsHtml = pack.materials
        .map((m, i) => {
          const mid = idBase + '-' + i
          const iconColor =
            m.type === 'report'
              ? '#4a5ff3'
              : m.type === 'bilingual'
                ? '#722ed1'
                : m.type === 'notice'
                  ? '#d98213'
                  : '#dc2626'
          const iconClass =
            m.type === 'report'
              ? 'fa-bar-chart'
              : m.type === 'bilingual'
                ? 'fa-globe'
                : m.type === 'notice'
                  ? 'fa-bell-o'
                  : 'fa-file-text-o'
          return `
          <div style="border:1px solid #e8ecf0;border-radius:10px;overflow:hidden;background:#fff;margin-bottom:${
  i < pack.materials.length - 1 ? '8px' : '0'
};">
            <div data-toggle-detail="${mid}" style="display:flex;align-items:center;gap:10px;padding:10px 12px;cursor:pointer;transition:background .15s;" onmouseover="this.style.background='#f8fafc'" onmouseout="this.style.background='#fff'">
              <i class="fa ${iconClass}" style="color:${iconColor};font-size:14px;flex-shrink:0;"></i>
              <div style="flex:1;min-width:0;overflow:hidden;">
                <div style="font-size:12px;font-weight:600;color:#374151;line-height:1.4;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${
  m.label
}</div>
              </div>
              <span style="font-size:11px;color:#4a5ff3;font-weight:600;flex-shrink:0;">查看详情 <i class="fa fa-chevron-down" style="font-size:9px;"></i></span>
            </div>
            <div id="${mid}" style="display:none;border-top:1px solid #e8ecf0;background:#fafbfc;padding:12px 14px;">
              <pre style="margin:0;font-size:11px;color:#4b5563;line-height:1.7;white-space:pre-wrap;word-wrap:break-word;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI','PingFang SC','Hiragino Sans GB','Microsoft YaHei',sans-serif;">${
  m.content
}</pre>
            </div>
          </div>
        `
        })
        .join('')

      const sec2 = `
        <div style="padding:14px;border-radius:12px;background:#fff;border:1px solid #e8ecf0;">
          <div style="font-size:13px;font-weight:700;color:#1f2937;margin-bottom:8px;display:flex;align-items:center;gap:6px;">
            <i class="fa fa-file-pdf-o" style="font-size:13px;color:#4a5ff3;"></i>
            <span>${pack.title}</span>
            <span style="margin-left:auto;font-size:10px;color:#52c41a;font-weight:600;">已生成 ${pack.materials.length} 份</span>
          </div>
          <div id="${introId}" style="font-size:11px;color:#5a6b7e;line-height:1.7;margin-bottom:10px;padding:8px 10px;background:#f8fafc;border-radius:6px;min-height:20px;"></div>
          <div id="${matWrapId}" style="display:none;opacity:0;transform:translateY(8px);transition:opacity 0.3s ease, transform 0.3s ease;">${materialsHtml}</div>
        </div>
      `

      const sec3 = `
        <div style="display:flex;gap:10px;">
          <button type="button" id="cso-export-pack-${aid}" style="flex:1;padding:8px 16px;border-radius:8px;border:none;background:#4a5ff3;color:#fff;font-size:12px;font-weight:600;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:6px;">
            <i class="fa fa-download" style="font-size:12px;"></i> 导出沟通材料包
          </button>
          <button type="button" onclick="window.csoSubmitToCeo()" style="flex:1;padding:8px 16px;border-radius:8px;border:1px solid #e8ecf0;background:#fff;color:#5a6b7e;font-size:12px;font-weight:600;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:6px;">
            <i class="fa fa-paper-plane" style="font-size:12px;"></i> 提交到CEO决策
          </button>
        </div>
      `

      const allSections = [sec1, sec2, sec3]
      const sectionIds = allSections.map((_, i) => `csop-psum-s${i}-${aid}`)
      const shell =
        '<div data-ceo-card="shell" style="background:#ffffff;border:1px solid #e8ecf0;border-radius:14px;padding:16px;box-shadow:0 4px 16px rgba(0,0,0,0.04);width:100%;min-width:280px;box-sizing:border-box;"><div style="min-width:0;width:100%;box-sizing:border-box;">' +
        allSections
          .map(
            (html, i) =>
              '<div id="' +
              sectionIds[i] +
              '" style="margin-bottom:10px;display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">' +
              html +
              '</div>'
          )
          .join('') +
        '</div></div>'
      this.appendLocalMessage('assistant', shell, true)

      // 区块0：方案概要 — 先显框架，再逐字输出推荐理由，完成后展示指标+共识
      setTimeout(() => {
        this.revealSection(sectionIds[0], 'block')
        setTimeout(() => {
          this.smartTypeWriterEffect(reasonId, summary.recommendReason, () => {
            setTimeout(() => {
              const ew = this._findVisibleEl(effectWrapId)
              if (ew) {
                ew.style.display = 'block'
                requestAnimationFrame(() => {
                  ew.style.opacity = '1'
                  ew.style.transform = 'translateY(0)'
                })
                this.scrollSmartChatToBottom()
              }
              // 区块1：沟通材料包 (等待区块0流式输出完全结束后再开始)
              setTimeout(() => {
                this.revealSection(sectionIds[1], 'block')
                setTimeout(() => {
                  this.smartTypeWriterEffect(introId, pack.intro, () => {
                    setTimeout(() => {
                      const mw = this._findVisibleEl(matWrapId)
                      if (mw) {
                        mw.style.display = 'flex'
                        mw.style.flexDirection = 'column'
                        requestAnimationFrame(() => {
                          mw.style.opacity = '1'
                          mw.style.transform = 'translateY(0)'
                        })
                        this.scrollSmartChatToBottom()
                      }
                      // 区块2：操作按钮 (等待区块1流式输出完全结束后再出现)
                      setTimeout(() => {
                        this.revealSection(sectionIds[2], 'block')
                        this.bindCsoExportPackHandler(aid, planKey, summary.commPack)
                      }, 1200)
                    }, 1200)
                  })
                }, 640)
              }, 1200)
            }, 1200)
          })
        }, 640)
      }, 520)
    },
    bindCsoExportPackHandler(aid, planKey, commPack) {
      const btn = this._findVisibleEl(`cso-export-pack-${aid}`)
      if (!btn) return
      const self = this
      btn.onclick = () => {
        // 静默下载：禁用按钮 1.2s 防重复点击，不显示任何提示
        btn.disabled = true
        try {
          self.exportCsoCommPack(commPack, planKey)
        } finally {
          setTimeout(() => {
            btn.disabled = false
          }, 1200)
        }
      }
    },
    // 生成每个材料的 Markdown 文件，并将所有 md 打包为 zip 下载
    exportCsoCommPack(commPack, planKey) {
      const planFileMap = {
        grade: '方案一_分级调价沟通材料包',
        unified: '方案二_统一涨价沟通材料包',
        internal: '方案三_内部消化沟通材料包'
      }
      const zipBaseName = planFileMap[planKey] || '客户调价沟通材料包'
      const now = new Date()
      const dateStr =
        now.getFullYear() +
        '-' +
        String(now.getMonth() + 1).padStart(2, '0') +
        '-' +
        String(now.getDate()).padStart(2, '0')

      const typeLabelMap = {
        report: '分析报告',
        letter: '沟通函',
        bilingual: '双语沟通函',
        notice: '内部通知'
      }

      // 1) 生成每个材料的 markdown
      const mdFiles = commPack.materials.map((m, idx) => {
        const safeLabel = String(m.label || `材料${idx + 1}`).replace(
          /[\\/:*?"<>|]/g,
          '_'
        )
        const fileName = `${String(idx + 1).padStart(2, '0')}_${
          typeLabelMap[m.type] || '材料'
        }_${safeLabel}.md`
        const header =
          `# ${safeLabel}\n\n` +
          `- **方案来源**：${commPack.title}\n` +
          `- **材料类型**：${typeLabelMap[m.type] || '材料'}\n` +
          `- **生成时间**：${dateStr}\n` +
          `- **序号**：${idx + 1} / ${commPack.materials.length}\n\n` +
          `---\n\n`
        const body = String(m.content || '').replace(/\r\n/g, '\n')
        return { fileName, content: header + body + '\n' }
      })

      // 2) 打包 zip（store-only，不压缩）
      const zipBytes = this.buildZipStoreOnly(
        mdFiles.map((f) => ({ name: f.fileName, data: f.content }))
      )
      const blob = new Blob([zipBytes], { type: 'application/zip' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `${zipBaseName}_${dateStr}.zip`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      setTimeout(() => URL.revokeObjectURL(url), 5000)

      // 4) 静默下载：不弹出任何提示
    },
    // 极简 ZIP 编码器：仅支持 store（不压缩）+ UTF-8 文件名，
    // 适用于纯文本 MD 文件，体积小、无需额外依赖。
    buildZipStoreOnly(files) {
      const encoder = new TextEncoder()
      const crcTable = (() => {
        const t = new Uint32Array(256)
        for (let n = 0; n < 256; n++) {
          let c = n
          for (let k = 0; k < 8; k++) {
            c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1
          }
          t[n] = c >>> 0
        }
        return t
      })()
      const crc32 = (bytes) => {
        let c = 0xffffffff
        for (let i = 0; i < bytes.length; i++) {
          c = crcTable[(c ^ bytes[i]) & 0xff] ^ (c >>> 8)
        }
        return (c ^ 0xffffffff) >>> 0
      }

      const localParts = []
      const centralParts = []
      let offset = 0

      files.forEach((f) => {
        const nameBytes = encoder.encode(f.name)
        const dataBytes = encoder.encode(f.data)
        const crc = crc32(dataBytes)
        const size = dataBytes.length

        // Local File Header
        const lh = new Uint8Array(30 + nameBytes.length)
        const lv = new DataView(lh.buffer)
        lv.setUint32(0, 0x04034b50, true) // signature
        lv.setUint16(4, 20, true) // version needed
        lv.setUint16(6, 0x0800, true) // flags: UTF-8
        lv.setUint16(8, 0, true) // method: store
        lv.setUint16(10, 0, true) // mod time
        lv.setUint16(12, 0x21, true) // mod date (1980-01-01)
        lv.setUint32(14, crc, true)
        lv.setUint32(18, size, true) // compressed size
        lv.setUint32(22, size, true) // uncompressed size
        lv.setUint16(26, nameBytes.length, true)
        lv.setUint16(28, 0, true) // extra length
        lh.set(nameBytes, 30)
        localParts.push(lh, dataBytes)

        // Central Directory Header
        const ch = new Uint8Array(46 + nameBytes.length)
        const cv = new DataView(ch.buffer)
        cv.setUint32(0, 0x02014b50, true) // signature
        cv.setUint16(4, 20, true) // version made by
        cv.setUint16(6, 20, true) // version needed
        cv.setUint16(8, 0x0800, true) // flags: UTF-8
        cv.setUint16(10, 0, true) // method: store
        cv.setUint16(12, 0, true) // mod time
        cv.setUint16(14, 0x21, true) // mod date
        cv.setUint32(16, crc, true)
        cv.setUint32(20, size, true) // compressed size
        cv.setUint32(24, size, true) // uncompressed size
        cv.setUint16(28, nameBytes.length, true)
        cv.setUint16(30, 0, true) // extra length
        cv.setUint16(32, 0, true) // comment length
        cv.setUint16(34, 0, true) // disk number start
        cv.setUint16(36, 0, true) // internal attrs
        cv.setUint32(38, 0, true) // external attrs
        cv.setUint32(42, offset, true) // local header offset
        ch.set(nameBytes, 46)
        centralParts.push(ch)

        offset += lh.length + dataBytes.length
      })

      const centralSize = centralParts.reduce((s, p) => s + p.length, 0)
      const centralOffset = offset

      // End of Central Directory
      const eocd = new Uint8Array(22)
      const ev = new DataView(eocd.buffer)
      ev.setUint32(0, 0x06054b50, true)
      ev.setUint16(4, 0, true) // disk number
      ev.setUint16(6, 0, true) // disk with central
      ev.setUint16(8, files.length, true)
      ev.setUint16(10, files.length, true)
      ev.setUint32(12, centralSize, true)
      ev.setUint32(16, centralOffset, true)
      ev.setUint16(20, 0, true) // comment length

      // 拼接所有部分
      const totalSize =
        localParts.reduce((s, p) => s + p.length, 0) + centralSize + eocd.length
      const out = new Uint8Array(totalSize)
      let pos = 0
      localParts.forEach((p) => {
        out.set(p, pos)
        pos += p.length
      })
      centralParts.forEach((p) => {
        out.set(p, pos)
        pos += p.length
      })
      out.set(eocd, pos)
      return out
    },
    renderCsoPlanConfirmationCard(planKey) {
      const planData = {
        grade: {
          planName: '方案一：分级调价',
          description:
            '分级调价方案已确认通过，已通知销售部启动客户沟通准备，预计7月1日起分批执行。',
          metrics: [
            { label: '预计覆盖成本', value: '967万/年', color: '#10b981' },
            { label: '覆盖比', value: '78%', color: '#4A5FF3' },
            { label: '执行日期', value: '7月1日', color: '#6b7280' }
          ]
        },
        unified: {
          planName: '方案二：统一涨价5%',
          description:
            '统一涨价方案已确认通过，已通知销售部启动客户沟通准备，预计7月15日起执行。',
          metrics: [
            { label: '预计覆盖成本', value: '930万/年', color: '#10b981' },
            { label: '覆盖比', value: '50%', color: '#4A5FF3' },
            { label: '执行日期', value: '7月15日', color: '#6b7280' }
          ]
        },
        internal: {
          planName: '方案三：内部消化',
          description: '内部消化方案已确认，已启动采购谈判、工艺优化、库存管理专项行动。',
          metrics: [
            { label: '内部降本目标', value: '1,860万', color: '#dc2626' },
            { label: '毛利率影响', value: '再降1.1pct', color: '#f59e0b' },
            { label: '风险等级', value: '高', color: '#dc2626' }
          ]
        }
      }

      const summary = planData[planKey]
      if (!summary) return

      const aid = 'cso-pcf-' + Date.now()
      const cnfTextId = 'cso-pcf-text-' + aid
      const sec1 = `
        <div style="padding:12px;border-radius:12px;background:linear-gradient(135deg,rgba(16,185,129,0.08),rgba(52,211,153,0.04));border:1px solid rgba(16,185,129,0.16);">
          <div style="font-size:12px;font-weight:700;color:#166534;margin-bottom:4px;">调价方案已确认</div>
          <div id="${cnfTextId}" style="font-size:11px;color:#475569;line-height:1.7;min-height:18px;"></div>
        </div>
      `

      const metricsHtml = summary.metrics
        .map(
          (m) => `
        <div style="flex:1;padding:10px;border-radius:10px;background:#f8fafc;border:1px solid #e8ecf0;">
          <div style="font-size:10px;color:#94a3b8;margin-bottom:4px;">${m.label}</div>
          <div style="font-size:16px;font-weight:700;color:${m.color};">${m.value}</div>
        </div>
      `
        )
        .join('')

      const sec2 = `<div style="display:flex;gap:8px;">${metricsHtml}</div>`

      const allSections = [sec1, sec2]
      const sectionIds = allSections.map((_, i) => `cso-pcf-s${i}-${aid}`)
      const shell =
        '<div data-ceo-card="shell" style="background:#ffffff;border:1px solid #e8ecf0;border-radius:14px;padding:16px;box-shadow:0 4px 16px rgba(0,0,0,0.04);width:100%;min-width:280px;box-sizing:border-box;"><div style="min-width:0;width:100%;box-sizing:border-box;"><div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;"><div style="width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,#10b981,#34d399);display:flex;align-items:center;justify-content:center;color:#ffffff;font-size:14px;font-weight:600;">S</div><div><div style="font-size:12px;font-weight:600;color:#1f2937;">供应链CSO数字人</div><div style="font-size:10px;color:#8c9bab;">刚刚</div></div></div>' +
        allSections
          .map(
            (html, i) =>
              '<div id="' +
              sectionIds[i] +
              '" style="margin-bottom:10px;display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">' +
              html +
              '</div>'
          )
          .join('') +
        '</div></div>'
      this.appendLocalMessage('assistant', shell, true)

      setTimeout(() => {
        this.revealSection(sectionIds[0], 'block')
        setTimeout(() => {
          this.smartTypeWriterEffect(cnfTextId, summary.description, () => {
            setTimeout(() => this.revealSection(sectionIds[1], 'block'), 1200)
          })
        }, 640)
      }, 520)
    },
    csoSubmitToCeo() {
      this.forceScrollToBottom()
      const aid = 'cso-stc-' + Date.now()
      const textId = 'cso-stc-text-' + aid
      const text =
        '已将本方案及全链路成本分析报告、客户沟通材料包一并提交至CEO决策队列。CEO数字人将在30分钟内反馈审批意见，届时我会同步推送结果并跟踪执行。'
      const sec1 = `
        <div style="padding:14px;border-radius:12px;background:linear-gradient(135deg,rgba(16,185,129,0.08),rgba(52,211,153,0.04));border:1px solid rgba(16,185,129,0.16);">
          <div style="font-size:13px;font-weight:700;color:#166534;margin-bottom:6px;">已提交到CEO决策</div>
          <div id="${textId}" style="font-size:12px;color:#475569;line-height:1.7;min-height:20px;"></div>
        </div>
      `
      const shell =
        '<div data-ceo-card="shell" style="background:#ffffff;border:1px solid #e8ecf0;border-radius:14px;padding:16px;box-shadow:0 4px 16px rgba(0,0,0,0.04);width:100%;min-width:280px;box-sizing:border-box;"><div style="min-width:0;width:100%;box-sizing:border-box;"><div id="cso-stc-s0-' +
        aid +
        '" style="display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">' +
        sec1 +
        '</div></div></div>'
      this.appendLocalMessage('assistant', shell, true)

      setTimeout(() => {
        this.revealSection('cso-stc-s0-' + aid, 'block')
        setTimeout(() => {
          this.smartTypeWriterEffect(textId, text)
        }, 800)
      }, 600)
    },
    csoShowDecisionDetail() {
      this.forceScrollToBottom()
      this.appendLocalMessage('user', '查看待决策事项详情')
      const aid = 'cso-dcd-' + Date.now()
      const dcdText1Id = `cso-dcd-t1-${aid}`
      const dcdText1 =
        '需要在份额稳盘与利润防线之间做出平衡，建议结合客户生命周期、订单结构与后续增购潜力决策。'
      const dcdText2Id = `cso-dcd-t2-${aid}`
      const dcdText2 =
        '<div style="font-size:12px;color:#475569;"><span style="color:#4A5FF3;">•</span> 当前三家重点客户未来30天内合计待决订单约1.2亿元。</div><div style="font-size:12px;color:#475569;"><span style="color:#4A5FF3;">•</span> 若执行限时防守报价，预计可保住68%订单，但综合毛利率将再下探约0.3pct。</div><div style="font-size:12px;color:#475569;"><span style="color:#4A5FF3;">•</span> 若保持底价纪律，短期收入会有缺口，但高毛利客户结构将更稳。</div>'
      const sec1 = `
        <div style="font-size:13px;font-weight:700;color:#1f2937;margin-bottom:8px;">华南重点客户防守报价决策</div>
        <div id="${dcdText1Id}" style="font-size:12px;color:#5a6b7e;line-height:1.7;margin-bottom:12px;min-height:18px;"></div>
      `
      const sec2 = `
        <div id="${dcdText2Id}" style="display:flex;flex-direction:column;gap:6px;min-height:18px;"></div>
      `
      const allSections = [sec1, sec2]
      const sectionIds = allSections.map((_, i) => `cso-dcd-s${i}-${aid}`)
      const shell =
        '<div data-ceo-card="shell" style="background:#ffffff;border:1px solid #e8ecf0;border-radius:14px;padding:16px;box-shadow:0 4px 16px rgba(0,0,0,0.04);width:100%;min-width:280px;box-sizing:border-box;"><div style="min-width:0;width:100%;box-sizing:border-box;"><div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;"><div style="width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,#f59e0b,#fbbf24);display:flex;align-items:center;justify-content:center;color:#ffffff;font-size:14px;font-weight:600;">S</div><div><div style="font-size:12px;font-weight:600;color:#1f2937;">供应链数字人</div><div style="font-size:10px;color:#8c9bab;">刚刚</div></div></div>' +
        allSections
          .map(
            (html, i) =>
              '<div id="' +
              sectionIds[i] +
              '" style="margin-bottom:10px;display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">' +
              html +
              '</div>'
          )
          .join('') +
        '</div></div>'
      this.appendLocalMessage('assistant', shell, true)

      setTimeout(() => {
        this.revealSection(sectionIds[0], 'block')
        setTimeout(() => {
          this.smartTypeWriterEffect(dcdText1Id, dcdText1, () => {
            setTimeout(() => {
              this.revealSection(sectionIds[1], 'block')
              setTimeout(() => {
                this.smartTypeWriterEffect(dcdText2Id, dcdText2)
              }, 800)
            }, 1200)
          })
        }, 600)
      }, 600)
    },
    csoShowInventory() {
      this.forceScrollToBottom()
      this.appendLocalMessage('user', '查看产品库存')
      const aid = 'cso-inv-' + Date.now()
      const invText1Id = `cso-inv-t1-${aid}`
      const invText1 =
        '库存周转52天基本持平，但呆滞库存286万集中在旧型号PCB与连接器，需专项清理释放资金。供应网络健康度78分，新引入5家供应商。'
      const invText3Id = `cso-inv-t3-${aid}`
      const invText3 =
        '<div style="padding:10px;border-radius:8px;background:#fef2f2;border:1px solid #fecaca;"><div style="display:flex;align-items:center;gap:6px;margin-bottom:4px;"><span style="padding:2px 6px;border-radius:4px;background:#ef4444;color:#ffffff;font-size:9px;font-weight:600;">预警</span><span style="font-size:12px;font-weight:600;color:#991b1b;">呆滞库存286万需清理</span></div><div style="font-size:11px;color:#64748b;">集中旧型号PCB(128万)与连接器(94万)，建议折价处理或拆解回收，预计可回收约140万。</div></div><div style="padding:10px;border-radius:8px;background:#f0fdf4;border:1px solid #bbf7d0;"><div style="display:flex;align-items:center;gap:6px;margin-bottom:4px;"><span style="padding:2px 6px;border-radius:4px;background:#22c55e;color:#ffffff;font-size:9px;font-weight:600;">中性</span><span style="font-size:12px;font-weight:600;color:#166534;">供应网络新增5家供应商</span></div><div style="font-size:11px;color:#64748b;">引入2家PCB替代供应商与3家连接器厂商，淘汰低效供应商3家，网络健康度从74提升至78分。</div></div>'
      const sec1 = `
        <div style="font-size:13px;font-weight:700;color:#1f2937;margin-bottom:8px;">库存与资金健康</div>
        <div id="${invText1Id}" style="font-size:12px;color:#5a6b7e;line-height:1.7;margin-bottom:12px;min-height:18px;"></div>
      `
      const sec2 = `
        <div style="display:flex;gap:10px;margin-bottom:12px;">
          <div style="flex:1;padding:10px;border-radius:8px;background:#f8fafc;border:1px solid #e8ecf0;">
            <div style="font-size:10px;color:#94a3b8;margin-bottom:2px;">库存周转</div>
            <div style="font-size:14px;font-weight:700;color:#16a34a;">52天</div>
          </div>
          <div style="flex:1;padding:10px;border-radius:8px;background:#fef2f2;border:1px solid #fecaca;">
            <div style="font-size:10px;color:#94a3b8;margin-bottom:2px;">呆滞库存</div>
            <div style="font-size:14px;font-weight:700;color:#dc2626;">286万</div>
          </div>
          <div style="flex:1;padding:10px;border-radius:8px;background:#f8fafc;border:1px solid #e8ecf0;">
            <div style="font-size:10px;color:#94a3b8;margin-bottom:2px;">供应网络健康</div>
            <div style="font-size:14px;font-weight:700;color:#16a34a;">78分</div>
          </div>
        </div>
      `
      const sec3 = `
        <div id="${invText3Id}" style="display:flex;flex-direction:column;gap:8px;min-height:18px;"></div>
      `
      const allSections = [sec1, sec2, sec3]
      const sectionIds = allSections.map((_, i) => `cso-inv-s${i}-${aid}`)
      const shell =
        '<div data-ceo-card="shell" style="background:#ffffff;border:1px solid #e8ecf0;border-radius:14px;padding:16px;box-shadow:0 4px 16px rgba(0,0,0,0.04);width:100%;min-width:280px;box-sizing:border-box;"><div style="min-width:0;width:100%;box-sizing:border-box;"><div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;"><div style="width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,#10b981,#34d399);display:flex;align-items:center;justify-content:center;color:#ffffff;font-size:14px;font-weight:600;">S</div><div><div style="font-size:12px;font-weight:600;color:#1f2937;">库存管理数字人</div><div style="font-size:10px;color:#8c9bab;">刚刚</div></div></div>' +
        allSections
          .map(
            (html, i) =>
              '<div id="' +
              sectionIds[i] +
              '" style="margin-bottom:10px;display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">' +
              html +
              '</div>'
          )
          .join('') +
        '</div></div>'
      this.appendLocalMessage('assistant', shell, true)

      setTimeout(() => {
        this.revealSection(sectionIds[0], 'block')
        setTimeout(() => {
          this.smartTypeWriterEffect(invText1Id, invText1, () => {
            setTimeout(() => this.revealSection(sectionIds[1], 'block'), 1000)
            setTimeout(() => {
              this.revealSection(sectionIds[2], 'block')
              setTimeout(() => {
                this.smartTypeWriterEffect(invText3Id, invText3)
              }, 800)
            }, 1500)
          })
        }, 600)
      }, 600)
    },
    async csoStepConfirmPricePlan() {
      this.forceScrollToBottom()
      const thinkingId = 'cso-confirm-thinking-' + Date.now()
      const thinkingSteps = [
        '正在汇总分级调价方案，校验各层级调价幅度与客户匹配性...',
        'A类客户校验通过：海尔/创维 调价3%，定制优惠+长期协议已就绪',
        'B类客户校验通过：长虹华意/东普永磁 调价5%，阶梯定价方案已确认',
        'C类客户校验通过：SharkNinja等 调价8%，AI沟通材料已生成',
        '综合测算：分级调价方案可覆盖成本967万/年，覆盖比例78%',
        '通知销售部启动客户沟通准备，预计7月1日起分批次执行',
        '方案已确认，正在输出调价执行计划...'
      ]
      this.appendLocalMessage(
        'assistant',
        this.renderCeoThinkingCard(
          thinkingId,
          thinkingSteps[0],
          '确认调价方案',
          '正在生成调价执行计划...',
          thinkingSteps.length
        ),
        true
      )
      let stepIdx = 1
      const thinkTimer = setInterval(() => {
        if (stepIdx < thinkingSteps.length) {
          this.updateCeoThinkingCard(thinkingId, thinkingSteps, stepIdx)
          stepIdx++
        } else {
          clearInterval(thinkTimer)
          this.removeThinkingCard(thinkingId)
          setTimeout(() => {
            this.renderCsoConfirmCard()
          }, 500)
        }
      }, 2000)
      this.smartAnalysisTimers.push(thinkTimer)
    },
    renderCsoConfirmCard() {
      const aid = 'cso-cf-' + Date.now()
      const cfTextId = 'cso-cf-text-' + aid
      const cfText =
        '分级调价方案已确认通过，已通知销售部启动客户沟通准备，预计7月1日起分批次执行。'
      const sec1 =
        '<div style="padding:14px;border-radius:10px;background:linear-gradient(135deg,rgba(16,185,129,0.08),rgba(52,211,153,0.04));border:1px solid rgba(16,185,129,0.16);"><div style="font-size:13px;font-weight:700;color:#166534;margin-bottom:6px;">调价方案已确认</div><div id="' +
        cfTextId +
        '" style="font-size:12px;color:#475569;line-height:1.7;min-height:18px;"></div></div>'
      const sec2 =
        '<div><div style="display:flex;gap:12px;margin-bottom:14px;"><div style="flex:1;padding:10px;border-radius:8px;background:#f8fafc;border:1px solid #e8ecf0;"><div style="font-size:10px;color:#94a3b8;margin-bottom:2px;">预计覆盖成本</div><div style="font-size:14px;font-weight:700;color:#16a34a;">967万/年</div></div><div style="flex:1;padding:10px;border-radius:8px;background:#f8fafc;border:1px solid #e8ecf0;"><div style="font-size:10px;color:#94a3b8;margin-bottom:2px;">覆盖比例</div><div style="font-size:14px;font-weight:700;color:#4a5ff3;">78%</div></div><div style="flex:1;padding:10px;border-radius:8px;background:#f8fafc;border:1px solid #e8ecf0;"><div style="font-size:10px;color:#94a3b8;margin-bottom:2px;">执行日期</div><div style="font-size:14px;font-weight:700;color:#1f2937;">7月1日</div></div></div><div style="font-size:11px;color:#94a3b8;">后续跟踪：销售部将在本周完成A类客户沟通铺垫，采购部同步跟踪供应商涨价执行情况。</div></div>'
      const allSections = [sec1, sec2]
      const sectionIds = allSections.map((_, i) => `cso-cf-s${i}-${aid}`)
      const shell =
        '<div data-ceo-card="shell" style="background:#ffffff;border:1px solid #e8ecf0;border-radius:14px;padding:16px;box-shadow:0 4px 16px rgba(0,0,0,0.04);width:100%;min-width:280px;box-sizing:border-box;"><div style="min-width:0;width:100%;box-sizing:border-box;"><div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;"><div style="width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,#10b981,#34d399);display:flex;align-items:center;justify-content:center;color:#fff;font-size:14px;font-weight:600;">S</div><div><div style="font-size:12px;font-weight:600;color:#1f2937;">供应链CSO数字人</div><div style="font-size:10px;color:#8c9bab;">刚刚</div></div></div>' +
        allSections
          .map(
            (html, i) =>
              '<div id="' +
              sectionIds[i] +
              '" style="margin-bottom:10px;display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">' +
              html +
              '</div>'
          )
          .join('') +
        '</div></div>'
      this.appendLocalMessage('assistant', shell, true)
      setTimeout(() => {
        this.revealSection(sectionIds[0], 'block')
        setTimeout(() => {
          this.smartTypeWriterEffect(cfTextId, cfText, () => {
            setTimeout(() => this.revealSection(sectionIds[1], 'block'), 1200)
          })
        }, 640)
      }, 520)
    },
    async csoStepInternalAbsorb() {
      this.forceScrollToBottom()
      const thinkingId = 'cso-internal-thinking-' + Date.now()
      const thinkingSteps = [
        '收到选择「内部消化」方案，正在评估可行性...',
        '内部消化路径：采购谈判降本约600万 + 工艺优化降本约500万 + 库存管理约400万',
        '合计可降本约1,500万，但年度新增成本1,860万仍有360万缺口',
        '内部消化将导致毛利率再降1.1pct，经营压力极大',
        '缺口分析：360万缺口需额外降本措施弥补，但目前无明确来源',
        '风险评估：内部消化方案仅适合短期客户关系维护场景，长期不可持续',
        '建议优先考虑成本传导方案，或采用部分传导+部分消化的混合策略',
        '评估完成，正在输出内部消化方案报告...'
      ]
      this.appendLocalMessage(
        'assistant',
        this.renderCeoThinkingCard(
          thinkingId,
          thinkingSteps[0],
          '内部消化评估',
          '正在评估内部消化方案的可行性...',
          thinkingSteps.length
        ),
        true
      )
      let stepIdx = 1
      const thinkTimer = setInterval(() => {
        if (stepIdx < thinkingSteps.length) {
          this.updateCeoThinkingCard(thinkingId, thinkingSteps, stepIdx)
          stepIdx++
        } else {
          clearInterval(thinkTimer)
          this.removeThinkingCard(thinkingId)
          setTimeout(() => {
            this.renderCsoInternalAbsorbCard()
          }, 500)
        }
      }, 2000)
      this.smartAnalysisTimers.push(thinkTimer)
    },
    renderCsoInternalAbsorbCard() {
      const aid = 'cso-ia-' + Date.now()
      const iaText1Id = `cso-ia-t1-${aid}`
      const iaText1 =
        '通过采购谈判、工艺优化、库存管理内部消化全部1,860万成本，毛利率将再降<strong style="color:#dc2626;font-weight:700;">1.1pct</strong>。仅适合短期客户关系维护场景，不可持续。'
      const iaText3Id = `cso-ia-t3-${aid}`
      const iaText3 =
        '<div style="padding:10px 12px;border-radius:10px;background:linear-gradient(135deg,rgba(16,185,129,0.08),rgba(52,211,153,0.04));border:1px solid rgba(16,185,129,0.16);margin-bottom:14px;"><div style="display:flex;align-items:center;gap:6px;"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg><span style="font-size:11px;color:#166534;font-weight:600;">共识: 决策skill提示高风险（仅供短期过渡）</span></div></div><div style="display:flex;align-items:center;justify-content:space-between;padding-top:12px;border-top:1px solid #e8ecf0;"><div style="display:flex;align-items:center;gap:6px;"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#4A5FF3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg><span style="font-size:11px;color:#4A5FF3;font-weight:600;">AI生成 · 内部消化成本管控通知 + 客户关系维护函</span></div><span style="font-size:11px;color:#10b981;font-weight:600;">已生成 2 份</span></div>'
      const sec1 = `
        <div style="padding:14px;border-radius:12px;background:#f8fafc;border:1px solid #e8ecf0;">
          <div style="display:flex;align-items:center;gap:8px;margin-bottom:8px;">
            <span style="padding:3px 8px;border-radius:8px;background:#4A5FF3;color:#ffffff;font-size:11px;font-weight:600;">已选方案</span>
            <span style="font-size:13px;font-weight:700;color:#1f2937;">方案三：内部消化（暂不调价）</span>
          </div>
          <div id="${iaText1Id}" style="font-size:12px;color:#475569;line-height:1.7;min-height:18px;"></div>
        </div>
      `
      const sec2 = `
        <div style="display:flex;gap:10px;">
          <div style="flex:1;padding:12px;border-radius:10px;background:#f8fafc;border:1px solid #e8ecf0;">
            <div style="font-size:10px;color:#94a3b8;margin-bottom:4px;">客户调价</div>
            <div style="font-size:16px;font-weight:700;color:#4A5FF3;">0%（零传导）</div>
          </div>
          <div style="flex:1;padding:12px;border-radius:10px;background:#f8fafc;border:1px solid #e8ecf0;">
            <div style="font-size:10px;color:#94a3b8;margin-bottom:4px;">内部降本目标</div>
            <div style="font-size:16px;font-weight:700;color:#1f2937;">1,860万</div>
          </div>
          <div style="flex:1;padding:12px;border-radius:10px;background:#f8fafc;border:1px solid #e8ecf0;">
            <div style="font-size:10px;color:#94a3b8;margin-bottom:4px;">毛利率影响</div>
            <div style="font-size:16px;font-weight:700;color:#dc2626;">再降1.1pct</div>
          </div>
          <div style="flex:1;padding:12px;border-radius:10px;background:#f8fafc;border:1px solid #e8ecf0;">
            <div style="font-size:10px;color:#94a3b8;margin-bottom:4px;">风险等级</div>
            <div style="font-size:14px;font-weight:700;color:#dc2626;">高（不可持续）</div>
          </div>
        </div>
      `
      const sec3 = `<div id="${iaText3Id}" style="min-height:18px;"></div>`
      const allSections = [sec1, sec2, sec3]
      const sectionIds = allSections.map((_, i) => `cso-ia-s${i}-${aid}`)
      const shell =
        '<div data-ceo-card="shell" style="background:#ffffff;border:1px solid #e8ecf0;border-radius:14px;padding:16px;box-shadow:0 4px 16px rgba(0,0,0,0.04);width:100%;min-width:280px;box-sizing:border-box;"><div style="min-width:0;width:100%;box-sizing:border-box;"><div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;"><div style="width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,#f59e0b,#fbbf24);display:flex;align-items:center;justify-content:center;color:#ffffff;font-size:14px;font-weight:600;">S</div><div><div style="font-size:12px;font-weight:600;color:#1f2937;">供应链数字人</div><div style="font-size:10px;color:#8c9bab;">刚刚</div></div></div>' +
        allSections
          .map(
            (html, i) =>
              '<div id="' +
              sectionIds[i] +
              '" style="margin-bottom:10px;display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">' +
              html +
              '</div>'
          )
          .join('') +
        '</div></div>'
      this.appendLocalMessage('assistant', shell, true)

      setTimeout(() => {
        this.revealSection(sectionIds[0], 'block')
        setTimeout(() => {
          this.smartTypeWriterEffect(iaText1Id, iaText1, () => {
            setTimeout(() => {
              this.revealSection(sectionIds[1], 'block')
              setTimeout(() => {
                this.revealSection(sectionIds[2], 'block')
                setTimeout(() => {
                  this.smartTypeWriterEffect(iaText3Id, iaText3)
                }, 640)
              }, 1200)
            }, 1200)
          })
        }, 640)
      }, 520)
    }
  }
}
